/* eslint-disable radix */
/* eslint-disable no-restricted-globals */
import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from 'react-toastify';
import InfoIcon from '@material-ui/icons/Error';
import Tooltip from '@material-ui/core/Tooltip';
import './form.css'
import Typography from "@material-ui/core/Typography";
import TextInputField from '../../infra/components/formInput/CustomTextInput'
import ComboboxInput from "../../infra/components/formInput/ComboboxInput"
import ActionAdd from '../../store/action/RegisterTemplate/Add'
import ActionEdit from '../../store/action/RegisterTemplate/Edit'
import ActionGetCategoryTemplate from '../../store/action/RegisterTemplate/FetchCategory'
import ActionGetLanguageTemplate from '../../store/action/RegisterTemplate/FetchLanguage'
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import { getListPublishedFlow } from '../../store/action/RegisterTemplate/Flow'
import { Modal } from 'react-bootstrap'
import ActionGetNameSpace from "../../store/action/RegisterTemplate/FetchNamespace";
import ActionUploadFileExample from '../../store/action/RegisterTemplate/UploadFileExample'
import { ClientId, SenderId } from "../../helper/HelperAuth";
import ActionGetAccessModuleIdAction from '../../store/action/AccessModule/FetchActionDispatch'
import ActionFetchAllDivision from '../../store/action/Division/FetchAll'
import ActionFetchSender from '../../store/action/Sender/FetchAll'
import PreviewMessage from "../../infra/components/PreviewMessage";
import EditorMessage from "../../infra/components/EditorMessage";
import ButtonManager from "../RegisterTemplate/ButtonManager";
import { URLFormat, PhoneNoFormat } from "../../infra/constants/regex";
import CheckBoxInputField from "../../infra/components/formInput/CustomCheckBoxInput";
import CardCarousel from "./CardCarousel";
import "./Styles.css";
import CardCarouselPreview from "./CardCarouselPreview";

class FormEdit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            filetype: '',
            flagjson: false,
            flagx: false,
            dismodal: false,
            totalcharname: 0,
            totalcharfooter: 0,
            totalcharhead: 0,
            totalchar: 0,
            tinyhtml: '',
            flagbutton: false,
            listLanguage: fromJS({}),
            form: fromJS({
                'template-id': '',
                'template-name': '',
                'template-type': '',
                'category-id': '',
                'client-id': '',
                'division-id': '',
                'sender-id': '',
                availableChange: '',
                namespace: '',
                show: false,
                actionType: '',
                item: fromJS({})
            }),
            statusDoc: 'viewList',
            loadded: false,
            typeDataTemp: '',
            errors: fromJS({}),
            error: '',
            formEdit: fromJS({
                'template-id': '',
                'template-name': '',
                'category-id': '',
                'language-id': '',
                'header-id': '',
                'message-template': '',
                'client-id': '',
                'division-id': '',
                'sender-id': '',
                'header-template': '',
                'header-example-template': '',
                'header-example-preview': '',
                'header-preview-final': '',
                'header-example-final': '',
                'body-template': '',
                'body-example-template': '',
                'body-example-preview': '',
                'body-preview-final': '',
                'footer-template': '',
                'template-buttons': [],
                'namespace': '',
                'selected-file': null,
                'idSessionTemplate': '',
                'idUploadTemplate': '',
                'file-key': Date.now(),
                'upload-completed': false,
                'add-security-recommendation': null,
                'code-expiration-minutes': 0,
                'limited-offer-text': '',
                'offer-has-expiration': false,
                "template-carousels": [],
            }),
            hideMediaHeader: 'hide',
            hideTextHeader: 'hide',
            hideExampleHeader: 'hide',
            hideBodyExample: 'hide',
            isAuthentication: false,
            formParamsBody: fromJS({}),
            formParamsBody2: fromJS({}),
            formParamsBody3: fromJS({}),
            parameterBody: fromJS({}),
            parameterBody2: fromJS({}),
            paramBody: 0,
            paramHeader: 0,
            paramHeaderExample: 0,
            paramCount: 0,
            arrayTemp: [""],
            flagempty: false,
            hideror: 'hide',
            disabledParent: false,
            disabledModal: true,
            disabledparam: false,
            disabledAll: true,
            tempHeader: '',
            counterLang: 1,
            wordingType1: '',
            wordingType2: '',
            counterParam: 0,
            wordingMessage1: '',
            wordingMessage2: '',
            modal: false,
            classButtonType1: 'col-sm-6 hide',
            classButtonMessage1: 'col-sm-12 hide',
            classButtonType2: 'col-sm-6 hide',
            classButtonMessage2: 'col-sm-12 hide',
            buttons: fromJS([
                {
                    'button-id': 'Website',
                    'button-id-value': 'URL'
                },
                {
                    'button-id': 'Phone',
                    'button-id-value': 'PHONE_NUMBER'
                },
            ]),
            templateHeader: fromJS([
                {
                    'header-id': 'hsm',
                    'header-name': 'Text'
                },
                {
                    'header-id': 'template',
                    'header-name': 'Media'
                },
            ]),
            headerMediaType: fromJS([
                {
                    'header-media-id': 'IMAGE'
                },
                {
                    'header-media-id': 'DOCUMENT'
                },
                {
                    'header-media-id': 'VIDEO'
                },
            ]),
            templateType: fromJS([
                {
                    'id': '',
                    'name': 'General'
                },
                {
                    'id': 'lto',
                    'name': 'LTO'
                },
                {
                    'id': 'coupon',
                    'name': 'Coupon'
                },
                {
                    'id': 'carousel',
                    'name': 'Carousel'
                },
                {
                    'id': 'catalog',
                    'name': 'Catalog'
                },
                {
                    'id': 'mpm',
                    'name': 'MPM'
                },
                {
                    'id': 'flow',
                    'name': 'Flow'
                },
            ]),
            bodyAuth: {
                id: '*{{1}}* adalah kode verifikasi Anda. Demi keamanan, jangan bagikan kode ini.',
                en: '*{{1}}* is your verification code. For your security, do not share this code.'
            },
            footerAuth: {
                id: 'Kode ini kedaluwarsa dalam',
                en: 'This code expires in'
            },
            statDisableButton: false, //untuk status button upload dan change
            statGetSessionIdTemp: false, //untuk menyatakan kalau example telah di upload
            fileNameExamp: '', //untuk menampilkan idUpload setelah di upload
            statButtonUpload: '', //button upload none atau tidak.
            statDisableButtonChange: true, //button upload none atau tidak.
            actionId: '',
            statusTemplate: '',
            limitedOfferTextLength: 16,
            editorHtml: "",
            editorHtmlCarousels: [""],
            headerTextOnly: false,
            listFlow: fromJS([])
        };

        this.showContent = this.showContent.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAddLanguage = this.handleAddLanguage.bind(this);
        this.handleListLanguage = this.handleListLanguage.bind(this);
        this.handleParamHeader = this.handleParamHeader.bind(this);
        this.renderAddLanguage = this.renderAddLanguage.bind(this);
        this.handleSaveDraft = this.handleSaveDraft.bind(this);
        this.handleEditedLanguage = this.handleEditedLanguage.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.renderModal = this.renderModal.bind(this);
        this.handleModal = this.handleModal.bind(this);
        this.handleCancelModal = this.handleCancelModal.bind(this);
        this.handleChangeParam = this.handleChangeParam.bind(this);
        this.renderParamBody = this.renderParamBody.bind(this);
        this.bodyBuild = this.bodyBuild.bind(this);
        this.handlesubmitModal = this.handlesubmitModal.bind(this);
        this.onEditorChange = this.onEditorChange.bind(this);
        this.handleOnFileChanged = this.handleOnFileChanged.bind(this);
        this.handleCancelFile = this.handleCancelFile.bind(this);
        this.handleUploadFile = this.handleUploadFile.bind(this);
        this.setParamSize = this.setParamSize.bind(this);
        this.onEditorCardCarouselChange = this.onEditorCardCarouselChange.bind(this);
        this.setParamSizeCardCarousel = this.setParamSizeCardCarousel.bind(this);
        this.handleChangeInCardCarousel = this.handleChangeInCardCarousel.bind(this);
        this.addMoreCardCarousel = this.addMoreCardCarousel.bind(this);
        this.deleteCardCarousel = this.deleteCardCarousel.bind(this);
        this.setJsonComponentCarousel = this.setJsonComponentCarousel.bind(this);
        this.getFlows = this.getFlows.bind(this);
    }

    async getFlows(clientId) {
        const body = {
            "client_id": clientId
        }
        const response = await getListPublishedFlow(body);
        if(response.ok){
            let data = await response.json();
            this.setState({listFlow: fromJS(data.data)})
        }
    }

    addMoreCardCarousel() {
        const { formEdit, editorHtmlCarousels } = this.state;
        let formVal = formEdit;
        let carousels = formEdit.get("template-carousels");
        let firstCarousel = formEdit.get("template-carousels").get(0);
        let newCarousel = firstCarousel.set("raw-message", "");
        newCarousel = newCarousel.set("raw_message", "");
        newCarousel = newCarousel.set("param_size", 0);
        formVal = formVal.set("template-carousels", fromJS([...carousels, newCarousel]));
        this.setState({ formEdit: formVal, editorHtmlCarousels: [...editorHtmlCarousels, ""] });
    }

    deleteCardCarousel(index) {
        const { formEdit, editorHtmlCarousels } = this.state;
        let valueHtmls = editorHtmlCarousels;
        let carousels = formEdit.get("template-carousels").delete(index);
        let formVal = formEdit.set("template-carousels", carousels);
        valueHtmls.splice(index, 1);
        this.setState({ formEdit: formVal, editorHtmlCarousels: valueHtmls });
    }
    
    onEditorCardCarouselChange(value, content, index) {
        const { formEdit, editorHtmlCarousels } = this.state;
        let editorHtmlCarouselsUpdate = editorHtmlCarousels;
        let carousels = formEdit.get("template-carousels");
        let carouselsUpdate = carousels.setIn([index, "raw_message"], value);
        let formVal = formEdit.set("template-carousels", carouselsUpdate);
        if (content) {
            editorHtmlCarouselsUpdate[index] = content;
            this.setState({ formEdit: formVal, editorHtmlCarousels: editorHtmlCarouselsUpdate });
        } else {
            this.setState({ formEdit: formVal });
        }
    }

    setParamSizeCardCarousel(paramSize, value, index) {
        let formVal = this.state.formEdit;
        let carousels = formVal.get("template-carousels");
        let carouselsUpdate = value
            ? carousels.mergeIn([index], {"param_size": paramSize, "raw_message": value })
            : carousels.setIn([index, "param_size"], paramSize);
        formVal = formVal.set("template-carousels", carouselsUpdate);
        this.setState({ formEdit: formVal });
    } 

    handleChangeInCardCarousel(field, value, index) {
        let formVal = this.state.formEdit;
        let carousels = formVal.get("template-carousels");
        let carouselsUpdate = carousels.setIn([index, field], value)
        formVal = formVal.set("template-carousels", carouselsUpdate);
        this.setState({ formEdit: formVal });
    }

    componentDidMount() {
        this.props.actionGetCategoryTemplate();
        this.props.actionGetAllClient();
        this.props.actionGetLanguageTemplate();
        this.props.actionGetAccessModuleIdAction('Register Template');
        this.props.actionFetchAllDivision(this.props.item.get('client_id'));
        this.props.actionFetchSender(this.props.item.get('client_id'));
        if (this.props.item.get('templateType') === 'flow') {
            this.getFlows(this.props.item.get('client_id'));
        }
    }

    onEditorChange(value, content) {
        let formVal = this.state.formEdit;
        
        formVal = formVal.set('body-template', value);
        formVal = formVal.set('body-preview-final', this.handleParamBodyExample(value));
        
        if (content) {
            this.setState({ formEdit: formVal, tinyhtml: content })
        } else {
            this.setState({ formEdit: formVal })
        }
    }

    setParamSize(paramSize, value) {
        this.setState({ disabledModal: paramSize <= 0 && this.state.paramHeader <= 0 });

        if(value) {
            let formVal = this.state.formEdit
            formVal = formVal.set('body-template', value)
            formVal = formVal.set('body-preview-final', this.handleParamBodyExample(value))
            this.setState({ formEdit: formVal })
        }
        this.setState({ paramBody: paramSize })
    }

    handleOnFileChanged(event) {
        let file = event.target.files[0]
        let filet = file.type.split("/")
        filet = filet[0]
        let newForm = this.state.formEdit;
        newForm = newForm.set("selected-file", event.target.files[0]);
        this.setState({
            formEdit: newForm,
            filetype: filet
        })
    }

    handleCancelFile() {
        let changeVals = this.state.formEdit;
        changeVals = changeVals.set('idSessionTemplate', '');
        changeVals = changeVals.set('idUploadTemplate', '');
        changeVals = changeVals.set('selected-file', null);
        changeVals = changeVals.set('file-key', Date.now());
        changeVals = changeVals.set('upload-completed', false);
        this.setState({ formEdit: changeVals, statGetSessionIdTemp: false, statDisableButtonChange: true, statDisableButton: false, fileNameExamp: '', statButtonUpload: '' });
    }

    async handleUploadFile() {
        const { form, formEdit, filetype } = this.state;
        let file = formEdit.get('selected-file');
        let headId = formEdit.get('header-id');
        let headTemp = formEdit.get('header-template');
        if (form.get('template-type') === 'carousel') {
            headTemp = formEdit.get('template-carousels').get(0).get('format').toUpperCase();
        }
        if (headTemp === "IMAGE" && filetype !== "image") {
            toast.error('Error Upload file make sure you uploaded the same format media you choose', toast.POSITION.TOP_RIGHT);
            return false
        }
        else if (headTemp === "VIDEO" && filetype !== "video") {
            toast.error('Error Upload file make sure you uploaded the same format media you choose', toast.POSITION.TOP_RIGHT);
            return false
        } else if (headTemp === "DOCUMENT" && (filetype === "video" || filetype == "image")) {
            toast.error('Error Upload file make sure you uploaded the same format media you choose', toast.POSITION.TOP_RIGHT);
            return false
        }
        if (file && headId === 'template' && (headTemp === 'IMAGE' || headTemp === 'DOCUMENT' || headTemp === 'VIDEO')) {
            let response = await this.props.actionUploadFileExample(file);
            if (response.get('success')) {
                
                let newForm = formEdit;
                newForm = newForm.set('idSessionTemplate', response.get('idSession'));
                newForm = newForm.set('idUploadTemplate', response.get('idUpload'));
                newForm = newForm.set('upload-completed', true);
                this.setState({
                    formEdit: newForm,
                    statGetSessionIdTemp: true,
                    statDisableButton: true,
                    statDisableButtonChange: false,
                    fileNameExamp: response.get('idUpload'),
                    statButtonUpload: 'none'
                })
            } else {
                toast.error('Error Upload file', toast.POSITION.TOP_RIGHT);
            }
        } else if (file && form.get('template-type') === 'carousel' && (headTemp === 'IMAGE' || headTemp === 'VIDEO')) {
            let response = await this.props.actionUploadFileExample(file);
            if (response.get('success')) {
                let newForm = formEdit;

                newForm = newForm.set('idSessionTemplate', response.get('idSession'));
                newForm = newForm.set('idUploadTemplate', response.get('idUpload'));
                newForm = newForm.set('upload-completed', true);
                this.setState({
                    formEdit: newForm,
                    statGetSessionIdTemp: true,
                    statDisableButton: true,
                    fileNameExamp: response.get('idUpload'),
                    statButtonUpload: 'none'
                })
            } else {
                toast.error('Error Upload file', toast.POSITION.TOP_RIGHT);
            }
        } else {
            toast.error('Check header option and file upload', toast.POSITION.TOP_RIGHT);
        }
    }

    handleChange(field, value, label) {
        var formVal = this.state.form;
        formVal = formVal.set(field, value);
        if (field === 'client-id') {
            this.props.actionFetchAllDivision(value);
            this.props.actionFetchSender(value);
        }
        if (field === 'category-id') {
            if (value === '1') {
                this.setState({ isAuthentication: true });
            } else {
                this.setState({ isAuthentication: false });
            }
        }
        this.setState({ form: formVal })
    }

    handleChangeEdit(field, value, label) {
        var formVal = this.state.formEdit;
        var charheader = this.state.totalcharhead
        var charfooter = this.state.totalcharfooter
        var charname = this.state.totalcharname
        if (field === 'header-id') {
            if (value === 'template') {
                this.setState({ hideMediaHeader: '' })
                this.setState({ hideTextHeader: 'hide' })
            } else {
                if (this.props.item.get('templateType') === 'lto') {
                    this.setState({ hideMediaHeader: 'hide', hideTextHeader: 'hide' })
                } else {
                    this.setState({ hideMediaHeader: 'hide', hideTextHeader: '' })
                }
            }
            this.setState({ paramHeader: 0 })
            if (this.state.paramBody === 0) {
                this.setState({disabledModal:true})
            }
            formVal = formVal.set(field, value).set('header-template', '')
            this.setState({ formEdit: formVal })
        }

        if (field === 'header-template') {
            if (formVal.get('header-id') == 'hsm') {
                formVal = formVal.set('header-preview-final', value);
                this.setState({ formEdit: formVal })
                let cekparamheader = ''
                let ind = 0;
                let tempstr = ''
                let flag = 0
                let paramarr = []
                if (value.length > 60) {
                    value = value.substr(0, 60)
                    charheader = value.length
                } else {
                    charheader = value.length
                }
                for (let i = 0; i < value.length; i++) {
                    var regex = /[^0-9]/g;
                    if (value[i] == "{" && value[i + 1] == "{") {
                        ind = value.indexOf("}", i)
                        if (ind < 0) {
                            continue
                        } else if (value[ind + 1] == "}") {
                            tempstr = value.substring(i + 2, ind)
                            if (tempstr.match(regex) == null) {
                                cekparamheader = value.substring(i, ind + 2);
                                if(formVal.get('header-example-template')) {
                                    formVal = formVal.set('header-preview-final', value.replace(cekparamheader, formVal.get('header-example-template')));
                                }
                                if (parseInt(tempstr) > 1 || parseInt(tempstr) < 1) {
                                    value = value.replace(cekparamheader, "")
                                    break
                                }
                                if (tempstr == paramarr[0]) {
                                    value = value.replace(cekparamheader, "")
                                    break
                                }
                                if (flag == 0) {
                                    paramarr.push(tempstr)
                                    flag += 1
                                    this.setState({ disabledModal: false, disabledparam: true, paramHeader: 1 })
                                } else {
                                    this.setState({ disabledModal: true, paramHeader: 0, hideror: 'hide' })
                                    continue
                                }

                            }
                        }
                    } else {
                        if (flag == 1) {
                            continue
                        } else {
                            if (this.state.paramBody > 0) {
                                this.setState({ disabledModal: false, disabledparam: false, paramHeader: 0 })
                            } else {
                                this.setState({ disabledModal: true, disabledparam: false, paramHeader: 0 })
                            }
                        }
                    }
                }
            }
        } if (field === 'template_name') {
            value = value.replace(/[^\w\s]/gi, '')
            value = value.replace(/ /g, "_");
            value = value.toLowerCase()

            if (value.length > 512) {
                value = value.substr(0, 512)
                charname = value.length
            } else {
                charname = value.length
            }
            formVal = formVal.set(field, value);
            this.setState({ form: formVal })
        }

        if (field === 'header-example-template') {
            let textHeader = this.state.formEdit.get('header-template')
            let textHeaderReplace = ''
            let stringParam = ''
            for (let i = 0; i < textHeader.length; i++) {

                if (textHeader[i] == "{" && textHeader[i + 1] == "{") {
                    stringParam = (textHeader.substring(i, i + 5))
                    textHeaderReplace = textHeader.replace(stringParam, " " + value + " ")
                }
            }
            formVal = formVal.set('header-example-template', value);
            formVal = formVal.set('header-example-preview', textHeaderReplace);
            this.setState({ formEdit: formVal })
        }
        if (field === 'footer-template') {
            if (value.length > 60) {
                value = value.substr(0, 60)
                charfooter = value.length
            } else {
                charfooter = value.length
            }
        }
        if (field === 'language-id') {
            formVal = this.handleMessageAuthType(formVal, formVal.get('category-id'), value, formVal.get('code-expiration-minutes'));
        }
        if (field === 'code-expiration-minutes') {
            formVal = this.handleMessageAuthType(formVal, formVal.get('category-id'), formVal.get('language-id'), value);
        }
        formVal = formVal.set(field, value);
        this.setState({ formEdit: formVal, totalcharhead: charheader, totalcharfooter: charfooter, totalcharname: charname })

    }

    async handleParamHeader() {
        const { formEdit, paramHeader } = this.state
        let formVal = this.state.formEdit
        let textBody = formEdit.get('header-template')
        let counterParam = paramHeader
        if (paramHeader > 0) {
            this.setState({ disabledparam: true, disabledModal: false })
            return false
        } else {
            this.setState({ disabledparam: false, disabledModal: true })
        }

        if (textBody.length > 54) {
            counterParam = 0
        } else {
            counterParam = counterParam + 1
            textBody = `${textBody} {{${counterParam}}}`
        }
        formVal = formVal.set('header-template', textBody);
        formVal = formVal.set('header-preview-final', textBody);
        this.setState({ formEdit: formVal })
        this.setState({ paramHeader: counterParam, totalcharhead: textBody.length })
        if (counterParam > 0) {
            this.setState({ disabledparam: true, disabledModal: false })
        } else {
            this.setState({ disabledparam: false, disabledModal: true })

            if (this.state.paramBody > 0) {
                this.setState({ disabledModal: false })
            }
        }

    }

    handleParamBodyExample(bodyValue) {
        const { formParamsBody, formEdit } = this.state;
        if (formEdit.get('category-id') === 1) {
            return bodyValue.replace('{{1}}', '123456')
        }
        //replace param if exist
        let stringIndex = ''
        let stringcheck = ''
        let index = 0
        let tempstr = ''
        let stringParam2 = ''
        var test_str = ''
        let strtempo = ''
        var regex = /[^0-9]/g;
        if (this.state.counterParam !== 0) {
            for (let i = 0; i < bodyValue.length; i++) {
                if (bodyValue[i] === "{" && bodyValue[i + 1] === "{") {
                    index = bodyValue.indexOf("}", i)
                    if (bodyValue[index + 1] === "}") {
                        strtempo = bodyValue.substring(i, index + 2)
                        if (strtempo.length > 4) {
                            let tempor = strtempo.substring(2, strtempo.length - 2)
                            if (tempor.match(regex) == null) {
                                stringIndex = bodyValue.substring(i, index + 2)
                                stringcheck = stringIndex.substring(2, stringIndex.length - 2)
                                tempstr = bodyValue.substring(i + 2, index)
                                if (parseInt(tempstr) > this.state.counterParam) continue
                                stringParam2 = (bodyValue.substring(i, index + 2))
                                if (formParamsBody.get("param-" + tempstr) === undefined
                                    || formParamsBody.get("param-" + tempstr) === ""
                                    || formParamsBody.get("param-" + tempstr) === ' ') continue
                                bodyValue = bodyValue.replace(stringParam2, formParamsBody.get("param-" + tempstr))
                                test_str = bodyValue
                            } else {
                                continue
                            }
                        } else {
                            continue
                        }
                    } else {
                        continue
                    }
                }
            }
        } else {
            test_str = bodyValue
        }
        return test_str;
    }

    validateForm(mediaType) {
        let {form, formEdit, formParamsBody, statGetSessionIdTemp} = this.state;

        //validation
        if (!form.get('client-id')) {
            toast.error('Client can not be empty', toast.POSITION.TOP_RIGHT);
            return false
        }

        if (!form.get('division-id')) {
            toast.error('Division can not be empty', toast.POSITION.TOP_RIGHT);
            return false
        }

        if (!form.get('sender-id')) {
            toast.error('Sender can not be empty', toast.POSITION.TOP_RIGHT);
            return false
        }

        if (!form.get('category-id')) {
            toast.error('Category can not be empty', toast.POSITION.TOP_RIGHT);
            return false
        }

        if (!form.get('template-name')) {
            toast.error('Template name can not be empty', toast.POSITION.TOP_RIGHT);
            return false
        }

        if (!formEdit.get('language-id')) {
            toast.error('Language can not be empty', toast.POSITION.TOP_RIGHT);
            return false
        }

        if (this.state.totalcharname > 512) {
            toast.error('Template message name reached maximum permitted,check your template name', toast.POSITION.TOP_RIGHT);
            return false
        }

        if(!this.state.isAuthentication) {
            if (!formEdit.get('body-template')) {
                toast.error('Body can not be empty', toast.POSITION.TOP_RIGHT);
                return false
            }
            if (formEdit.get('header-id') == 'template' && (mediaType === '' || mediaType == null)) {
                toast.error('Header Template can not be empty', toast.POSITION.TOP_RIGHT);
                return false
            }
            let cond = this.state.flagempty
            if (this.state.paramBody > 0) {
                if ((this.state.counterParam !== this.state.paramBody) || !cond) {
                    if (this.state.paramBody > formParamsBody.size) {
                        toast.error('Body sample is mandatory please add sample for body parameter before submit', toast.POSITION.TOP_RIGHT);
                        this.setState({ hideror: '' })
                        return false
                    }
                }
            }
            if ((formEdit.get('header-example-template') == '' || formEdit.get('header-example-template') == "") && this.state.paramHeader > 0) {
                toast.error('Header sample is mandatory please add sample for header parameter before submit', toast.POSITION.TOP_RIGHT);
                this.setState({ hideror: '' })
                return false
            }

            if (form.get('header-id') == 'template' && form.get('upload-completed') !== true) {
                toast.error('Media file must be uploaded', toast.POSITION.TOP_RIGHT);
                return false
            }

            if (this.state.totalchar > 1024) {
                toast.error('Body message template reach maximum character permitted,check body message template', toast.POSITION.TOP_RIGHT);
                return false
            }

            if (formEdit.get('body-template').match("\n\n\n")) {
                toast.error('Body message template contains more than 2 concecutive spacing enter check your body message', toast.POSITION.TOP_RIGHT);
                return false
            }

            if (form.get('template-type') === 'lto') {
                if (!formEdit.get('limited-offer-text').length) {
                    toast.error('Limitted-offer text must be filled')
                    return false
                }
            }
            if (form.get('template-type') === 'lto' && formEdit.get('header-id') === 'template') {
                if (formEdit.get('header-template') !== 'IMAGE' && formEdit.get('header-template') !== 'VIDEO') {
                    toast.error('Media Type must be IMAGE or VIDEO', toast.POSITION.TOP_RIGHT);
                    return false
                }
            }

            if (form.get('template-type') === 'mpm') {
                if (formEdit.get('header-template') === '' || formEdit.get('header-template') == null) {
                    toast.error('A header is required for templates MPM', toast.POSITION.TOP_RIGHT);
                    return false
                }
            }

            if (form.get('template-type') === 'catalog' || form.get('template-type') === 'lto' || form.get('template-type') === 'mpm' || form.get('template-type') === 'flow') {
                if (formEdit.get('template-buttons').size === 0) {
                    toast.error('Button field is mandatory')
                    return false
                }
            }

            if (form.get('template-type') === 'carousel') {
                if(!this.validateCarousel(formEdit.get('template-carousels'))) return false;
                if (!statGetSessionIdTemp) {
                    toast.error('Card header sample is mandatory please add sample for card header parameter before submit', toast.POSITION.TOP_RIGHT);
                    return false;
                }
            }
        } else {
            if (formEdit.get('code-expiration-minutes') > 90) {
                toast.error("Code Expiration can't more than 90", toast.POSITION.TOP_RIGHT);
                return false
            }

            if(formEdit.get('template-buttons').size < 1) {
                toast.error('Button field is mandatory', toast.POSITION.TOP_RIGHT);
                return false
            }
        }

        return this.validateTemplateButtons(formEdit.get('template-buttons'));
    }

    validateTemplateButtons(templateButtons) {
        const { formEdit, form } = this.state;
        var isValid = true
        let hasCopyCode = false;
        let copyCodeIndex;
        let hasUrlBtn = false;
        let listError = [];
        templateButtons.forEach((button, index) => {
            if (button.get('button_message').length > 25) {
                listError.push('Button Message must be less than 25 characters');
            } else if (button.get('button_message').length === 0) {
                listError.push('Button Message must be filled');
            } else if (button.get('button_message').replace(/\s/g, '').length === 0) {
                listError.push('Button Message must be filled');
            }
        
            let buttonType = button.get('button_type') == null ? '' : button.get('button_type');
            switch (buttonType.toLowerCase()) {
                case 'url':    
                    if (formEdit.get('category-id') !== '1') {
                        hasUrlBtn = true;
                        if (button.get('button_value').length === 0) listError.push('URL must be filled');
                        else if (!button.get('button_value').match(URLFormat)) listError.push("Invalid URL format, use 'protocol://address'");
                        else if (button.get('value_type') === '') listError.push('Please select URL Type');
                        else if (button.get('button_value').includes('{{1}}') && button.get('value_type') !== 'dynamic') listError.push('Please select URL Type Dynamic if the URL have a param tag');
                        else if (!button.get('button_value').includes('{{1}}') && button.get('value_type') === 'dynamic') listError.push('Please add a param tag in URL if the URL Type is Dynamic');
                    } else {
                        if (button.get('otp_type')) {
                            if (button.get('otp_type') === 'ONE_TAP') {
                                if (!button.get('signature_hash') || !button.get('package_name') || !button.get('autofill_text')) {
                                    listError.push("Autofill text, Package Name, and Signature Hash must be filled");
                                }
                            }
                        }
                    }
                    break
                case 'phone_number':
                    if (button.get('button_value').length === 0)
                        listError.push('Phone Number must be filled');
                    else if (!button.get('button_value').match(PhoneNoFormat))
                        listError.push('Invalid phone number format');
                    break
                case 'quick_reply':
                    break
                case 'catalog':
                    break
                case 'mpm':
                    break
                case 'flow':
                    break
                case "copy_code":
                    hasCopyCode = true;
                    copyCodeIndex = index;
                    break;
                default:
                    listError.push('Invalid Button Type');
            }
        })

        if (form.get("template-type") === "coupon" && !hasCopyCode) {
            listError.push("Coupon template must have a copy code button");
        }

        if (form.get("template-type") === "lto" && hasCopyCode && copyCodeIndex !== 0) {
            listError.push("The copy code button should be first");
        }
        if (form.get("template-type") === "lto" && !hasUrlBtn) {
            listError.push("URL button is required");
        }

        if (listError.length > 0) {
            isValid = false;
            listError.forEach(error => toast.error(error, toast.POSITION.TOP_RIGHT))
        }
    
        return isValid
    }

    validateCarousel(carousel) {
        let isValid = true;
        let listError = []
        let isButtonCardValid = true;
        let isFormatValid = true;
        let isMessageValid = true;
        let isAllCardHaveButton = true;
        let isAllCardHaveSameButton = true;

        const formatFirstCard = carousel.getIn([0, "format"]);
        const firstCardButton = carousel.getIn([0, "template-buttons"]);

        carousel.forEach((card) => {
            const isButtonValid = this.validateTemplateButtons(card.get("template-buttons"))
            if (!isButtonValid) {
                isButtonCardValid = false;
            }
            if (!card.get("template-buttons").size) {
                isAllCardHaveButton = false;
            }
            if (card.get("template-buttons").size !== firstCardButton.size) {
                isAllCardHaveSameButton = false;
            } else {
                for (let index = 0; index < card.get("template-buttons").size; index++) {
                    if (card.get("template-buttons").getIn([index, "button-type"]) !== firstCardButton.getIn([index, "button-type"])) {
                        isAllCardHaveSameButton = false;
                    }
                }
            }
            if (card.get("format") !== formatFirstCard || !card.get("format") || card.get("format") === "") {
                isFormatValid = false;
            }
            if (!card.get("raw_message").length) {
                isMessageValid = false;
            }
        })

        if (!isFormatValid) {
            listError.push("The card header format must have selected Image or Video and must be the same on all cards")
        }
        if (!isMessageValid) {
            listError.push("The card body message must be filled")
        }
        if (!isAllCardHaveButton) {
            listError.push("At least one button required for a card")
        }
        if (!isAllCardHaveSameButton) {
            listError.push("Each card must have the same number of buttons and the same button type")
        }
        if (!isButtonCardValid) {
            isValid = false;
        }
        if (listError.length > 0) {
            isValid = false;
            listError.forEach(error => toast.error(error, toast.POSITION.TOP_RIGHT))
        }

        return isValid;
    }

    setJsonComponentCarousel(card, form){
        let jsonRequestCarousel = [];
        let headerRequest = {
            "type": "HEADER",
            "format": card.get('format').toUpperCase(),
            "example": {
                "header_handle": [form.get('idUploadTemplate')]
            }
        };
        let bodyRequest = {
            "type": "BODY",
            "text": card.get('raw_message')
        };
        if (card.get('param_size') > 0) {
            let exampleBodyText = [];
            for (let i = 0; i < card.get('param_size'); i++) {
                exampleBodyText.push('example'+(i+1))
            }
            bodyRequest["example"] = {
                "body_text": [exampleBodyText]
            }
        }
        
        let listRequestButton = [];
        card.get('template-buttons').forEach((btn, idx) => {
            let btnType = btn.get('button_type') ? btn.get('button_type').toLowerCase() : '';
            if(btnType === 'quick_reply') {
                listRequestButton.push({
                    type: 'QUICK_REPLY',
                    text: btn.get('button_message'),
                });
            }
            if(btnType === 'phone_number') {
                listRequestButton.push({
                    type: btn.get('button_type'),
                    text: btn.get('button_message'),
                    phone_number: btn.get('button_value'),
                });
            }
            if(btnType === 'url') {
                listRequestButton.push({
                    type: btn.get('button_type'),
                    text: btn.get('button_message'),
                    url: btn.get('button_value'),
                    example:[
                        btn.get('button_value').replace('{{1}}', 'example')
                    ]
                });
            }
        })
        let buttonRequest = {
            "type": "BUTTONS",
            "buttons": listRequestButton
        }
        jsonRequestCarousel.push(headerRequest);
        jsonRequestCarousel.push(bodyRequest);
        jsonRequestCarousel.push(buttonRequest);
        return jsonRequestCarousel;
    }

    generateJsonRequest() {
        const { formEdit, counterParam, paramBody, paramHeader, formParamsBody, form } = this.state;
        let existButton = false
        let buttonJson = {}
        let footerJson = {}
        let headerJson = {}
        let bodyJson = {}
        let jsonRequest = []
        let examplebody = []

        for (let i = 0; i < paramBody; i++) {
            examplebody.push(formParamsBody.get("param-" + (i + 1)))
        }

        if(this.state.isAuthentication) {
            bodyJson = {"type": "BODY"}
            footerJson = {"type": "FOOTER"}
            if(formEdit.get('add-security-recommendation') !== null) bodyJson["add_security_recommendation"] = formEdit.get('add-security-recommendation');
            if(formEdit.get('code-expiration-minutes') > 0) footerJson['code_expiration_minutes'] = parseInt(formEdit.get('code-expiration-minutes'));
            jsonRequest.push(bodyJson);
            jsonRequest.push(footerJson);
        } else {
            if (formEdit.get('body-template') !== '' && counterParam > 0) {
                bodyJson = {
                    "type": "BODY",
                    "text": formEdit.get('body-template'),
                    "example": {
                        "body_text": [examplebody]
                    }
                }
                jsonRequest.push(bodyJson)
            } else if (formEdit.get('body-template') !== '') {
                bodyJson = {
                    "type": "BODY",
                    "text": formEdit.get('body-template')
                }
                jsonRequest.push(bodyJson)
            }
    
            if (formEdit.get('header-id') === 'template') {
                if (formEdit.get('idUploadTemplate') !== "") {
                    headerJson = {
                        "type": "HEADER",
                        "format": formEdit.get('header-template'),
                        "example": {
                            "header_handle": formEdit.get('idUploadTemplate')
                        }
                    }
                } else {
                    headerJson = {
                        "type": "HEADER",
                        "format": formEdit.get('header-template')
                    }
                }
                jsonRequest.push(headerJson)
            } else {
                if (formEdit.get('header-template') !== '' && paramHeader > 0) {
                    headerJson = {
                        "type": "HEADER",
                        "format": 'TEXT',
                        "text": formEdit.get('header-template'),
                        "example": {
                            "header_text": [formEdit.get('header-example-final')]
                        }
                    }
                    jsonRequest.push(headerJson)
                } else if (formEdit.get('header-template') !== '') {
                    headerJson = {
                        "type": "HEADER",
                        "format": 'TEXT',
                        "text": formEdit.get('header-template'),
                    }
                    jsonRequest.push(headerJson)
                }
            }

            if (form.get('template-type') === 'lto') {
                jsonRequest.push({
                    "type": "limited_time_offer",
                    "limited_time_offer":{
                        "text": formEdit.get('limited-offer-text'),
                        "has_expiration": formEdit.get('offer-has-expiration')
                    }
                });
            }

            if (form.get('template-type') === 'carousel') {
                let carouselItems = formEdit.get('template-carousels');
                let cardsCarousel = [];
                carouselItems.forEach((item, index) => {
                    let jsonRequestCarousel = this.setJsonComponentCarousel(item, formEdit);
                    cardsCarousel.push({
                        "components": jsonRequestCarousel,
                    });
                });
                jsonRequest.push({
                    "type": "CAROUSEL",
                    "cards": cardsCarousel
                });
            }
    
            if (formEdit.get('footer-template') !== '') {
                footerJson = {
                    "type": "FOOTER",
                    "text": formEdit.get('footer-template')
                }
                jsonRequest.push(footerJson)
            }
        }

        let templateButtons = formEdit.get('template-buttons').toJS();
        if (templateButtons.length > 0) {
            existButton = true
            let jsonRequestButton = [];
            for(let i = 0; i < templateButtons.length; i++) {
                let buttonType = templateButtons[i].button_type ? templateButtons[i].button_type.toLowerCase() : '';
                if(buttonType === 'quick_reply') {
                    jsonRequestButton.push({
                        type: 'QUICK_REPLY',
                        text: templateButtons[i].button_message,
                    });
                } else if (buttonType === 'copy_code'){
                    jsonRequestButton.push({
                        type: 'copy_code',
                        example: 'example123',
                    });
                } else if (buttonType === 'url') {
                    if(templateButtons[i].otp_type) {
                        if(templateButtons[i].otp_type === 'COPY_CODE') {
                            jsonRequestButton.push({
                                type: 'OTP',
                                otp_type: templateButtons[i].otp_type,
                                text: templateButtons[i].button_message,
                            });
                        } else if (templateButtons[i].otp_type === 'ONE_TAP') {
                            jsonRequestButton.push({
                                type: 'OTP',
                                otp_type: templateButtons[i].otp_type,
                                text: templateButtons[i].button_message,
                                autofill_text: templateButtons[i].autofill_text,
                                package_name: templateButtons[i].package_name,
                                signature_hash: templateButtons[i].signature_hash,
                            });
                        }
                    } else {
                        jsonRequestButton.push({
                            type: templateButtons[i].button_type,
                            text: templateButtons[i].button_message,
                            url: templateButtons[i].button_value,
                            example:[
                                templateButtons[i].button_value.replace('{{1}}', 'example' + (i+1))
                            ]
                        });
                        
                    }
                } else if (buttonType === 'phone_number') {
                    jsonRequestButton.push({
                        type: templateButtons[i].button_type,
                        text: templateButtons[i].button_message,
                        phone_number: templateButtons[i].button_value,
                    });
                } else if (buttonType === 'catalog' || buttonType === 'mpm') {
                    jsonRequestButton.push({
                        type: templateButtons[i].button_type,
                        text: templateButtons[i].button_message,
                    });
                } else if (buttonType === 'flow') {
                    jsonRequestButton.push({
                        type: templateButtons[i].button_type,
                        text: templateButtons[i].button_message,
                        flow_id: templateButtons[i].flow_id,
                        navigate_screen: templateButtons[i].navigate_screen,
                        flow_action: templateButtons[i].flow_action,
                    });
                }
            }

            buttonJson = {
                "type": "BUTTONS",
                "buttons": jsonRequestButton
            }
        }

        if (existButton === true) jsonRequest.push(buttonJson)

        return JSON.stringify(jsonRequest);
    }

    setRequestCarousel(carouselItems){
        const { formEdit } = this.state;
        let carouselRequest = [];
        carouselItems.forEach((item, index) => {
            let jsonRequest = this.setJsonComponentCarousel(item, formEdit);
            let carouselItem = {
                "jsonRequest": JSON.stringify(jsonRequest),
                "raw_message": item.get('raw_message'),
                "format": item.get('format').toUpperCase(),
                "idUpload": formEdit.get('idUploadTemplate'),
                "total_param_body": item.get('param_size'),
                "button": item.get('template-buttons').toJS()
            }
            carouselRequest.push(carouselItem);
        });
        return carouselRequest;
    }

    async handleSubmit() {
        const { form, formEdit, paramBody, paramHeader, typeDataTemp, statusTemplate } = this.state;
        let mediaType = "";
        let rawHeader = "";
        let formatJrHeader = formEdit.get('header-id');
        let strHeaderId = '';
        if (formEdit.get('header-id') === 'template') {
            mediaType = formEdit.get('header-template').toLowerCase();
            strHeaderId = 'template';
        } else {
            if (formEdit.get('header-id') === 'hsm') {
                rawHeader = formEdit.get('header-template');
            }
            mediaType = 'text'
            formatJrHeader = 'TEXT';
            strHeaderId = 'hsm';
        }

        if(!this.validateForm(mediaType)) return false;

        let varidTemplateDetail = '';
        let varidSession = '';
        let varidUpload = '';

        if (formEdit.get('template-detail-id') !== undefined) {
            varidTemplateDetail = formEdit.get('template-detail-id');
        }
        if (formEdit.get('idSessionTemplate') !== undefined) {
            varidSession = formEdit.get('idSessionTemplate');
        }
        if (formEdit.get('idUploadTemplate') !== undefined) {
            varidUpload = formEdit.get('idUploadTemplate');
        }

        let messageDetail = {
            "idTemplateDetail": varidTemplateDetail,
            "lang_code": formEdit.get('language-id'),
            "jsonRequest": this.generateJsonRequest(),
            "statusTemplate": statusTemplate > 0 ? statusTemplate : '1',
            'button': formEdit.get('template-buttons'),
        }

        if (mediaType !== 'text') {
            messageDetail['idUpload'] = varidUpload;
            messageDetail['idSession'] = varidSession;
        }
        
        if(form.get('category-id') === '1') {
            messageDetail['type'] = 'hsm';
            messageDetail['media_type'] = 'text';
            messageDetail['add_security_recommendation'] = formEdit.get('add-security-recommendation');
            messageDetail['code_expiration_minutes'] = formEdit.get('code-expiration-minutes');
            messageDetail['raw_message'] = formEdit.get('body-template');
            messageDetail['raw_message_footer'] = formEdit.get('footer-template');
            messageDetail['total_param_body'] = 1;
        } else {
            messageDetail['type'] = strHeaderId;
            messageDetail['media_type'] = mediaType;
            messageDetail['raw_message'] = formEdit.get('body-template');
            messageDetail['raw_message_header'] = rawHeader;
            messageDetail['raw_message_footer'] = formEdit.get('footer-template');
            messageDetail['total_param_body'] = `${paramBody}`;
            messageDetail['total_param_header'] = `${paramHeader}`;

            if (form.get('template-type') === "lto") {
                messageDetail['limited_offer_text'] = formEdit.get('limited-offer-text');
                messageDetail['offer_has_expiration'] = formEdit.get('offer-has-expiration')===true ? 1 : 0;
            }
            if (form.get('template-type') === 'carousel') {
                messageDetail['carousel'] = this.setRequestCarousel(formEdit.get("template-carousels"));
                messageDetail['idUpload'] = varidUpload;
                messageDetail['idSession'] = varidSession;
            }
        }

        let varActionId = this.state.actionId;
        var varSender = "";
        if (varActionId == 5) {
            varSender = SenderId;
        }

        let data = {
            "idTemplateMessage": formEdit.get('template-id'),
            "client_id": `${formEdit.get('client-id')}`,
            "division_id": formEdit.get('division-id'),
            "sender_id": formEdit.get('sender-id'),
            "sender-id": varSender,
            "templateType": form.get('template-type'),
            "name_space": form.get('namespace'),
            "idCategory": form.get('category-id'),
            "templateName": form.get('template-name'),
            "messageDetail": messageDetail
        }
        let body = {
            "data": data
        }

        if (typeDataTemp === 'edit') {
            let responseEdit = await this.props.actionEdit(body)
            if (responseEdit.ok) {
                toast.success('Data has been Updated!', toast.POSITION.TOP_RIGHT);
                this.props.handleCancelForm(true);
            } else {
                toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
            }
        } else {
            let response = await this.props.actionAdd(body)
            if (response.ok) {
                toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
                this.props.handleCancelForm(true);
            } else {
                toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
            }
        }
    }

    async handleSaveDraft() {
        const { form, formEdit, paramBody, paramHeader, typeDataTemp } = this.state;
        let mediaType = "";
        let rawHeader = "";
        let formatJrHeader = formEdit.get('header-id');
        let strHeaderId = '';
        if (formEdit.get('header-id') === 'template') {
            mediaType = formEdit.get('header-template').toLowerCase();
            strHeaderId = 'template';
        } else {
            if (formEdit.get('header-id') === 'hsm') {
                rawHeader = formEdit.get('header-template');
            }
            mediaType = 'text'
            formatJrHeader = 'TEXT';
            strHeaderId = 'hsm';
        }

        if(!this.validateForm(mediaType)) return false;

        let varidTemplateDetail = '';
        let varidSession = '';
        let varidUpload = '';

        if (formEdit.get('template-detail-id') !== undefined) {
            varidTemplateDetail = formEdit.get('template-detail-id');
        }
        if (formEdit.get('idSessionTemplate') !== undefined) {
            varidSession = formEdit.get('idSessionTemplate');
        }
        if (formEdit.get('idUploadTemplate') !== undefined) {
            varidUpload = formEdit.get('idUploadTemplate');
        }

        let messageDetail = {
            "idTemplateDetail": varidTemplateDetail,
            "lang_code": formEdit.get('language-id'),
            "jsonRequest": this.generateJsonRequest(),
            "statusTemplate": "0",
            'button': formEdit.get('template-buttons'),
        }

        if (mediaType !== 'text') {
            messageDetail['idUpload'] = varidUpload;
            messageDetail['idSession'] = varidSession;
        }

        if(formEdit.get('category-id') === '1') {
            messageDetail['type'] = 'hsm';
            messageDetail['media_type'] = 'text';
            messageDetail['add_security_recommendation'] = formEdit.get('add-security-recommendation');
            messageDetail['code_expiration_minutes'] = formEdit.get('code-expiration-minutes');
            messageDetail['raw_message'] = formEdit.get('body-template');
            messageDetail['raw_message_footer'] = formEdit.get('footer-template');
            messageDetail['total_param_body'] = 1;
        } else {
            messageDetail['type'] = strHeaderId;
            messageDetail['media_type'] = mediaType;
            messageDetail['raw_message'] = formEdit.get('body-template');
            messageDetail['raw_message_header'] = rawHeader;
            messageDetail['raw_message_footer'] = formEdit.get('footer-template');
            messageDetail['total_param_body'] = `${paramBody}`;
            messageDetail['total_param_header'] = `${paramHeader}`;

            if (form.get('template-type') === "lto") {
                messageDetail['limited_offer_text'] = formEdit.get('limited-offer-text');
                messageDetail['offer_has_expiration'] = formEdit.get('offer-has-expiration')===true ? 1 : 0;
            }
            if (form.get('template-type') === 'carousel') {
                messageDetail['carousel'] = this.setRequestCarousel(formEdit.get("template-carousels"));
                messageDetail['idUpload'] = varidUpload;
                messageDetail['idSession'] = varidSession;
            }
        }

        let data = {
            "client_id": `${form.get('client-id')}`,
            "division_id": form.get('division-id'),
            "sender_id": form.get('sender-id'),
            "name_space": form.get('namespace'),
            "idTemplateMessage": form.get('template-id'),
            "idCategory": form.get('category-id'),
            "templateName": form.get('template-name'),
            "templateType": form.get('template-type'),
            "messageDetail": messageDetail
        }
        let body = {
            "data": data
        }
        
        if (typeDataTemp == 'edit') {
            let responseEdit = await this.props.actionEdit(body)
            if (responseEdit.ok) {
                toast.success('Data has been Updated!', toast.POSITION.TOP_RIGHT);
                this.props.handleCancelForm(true);
            } else {
                toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
            }
        } else {
            let response = await this.props.actionAdd(body)
            if (response.ok) {
                toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
                this.props.handleCancelForm(true);
            } else {
                toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
            }
        }
    }

    handleEditedLanguage(idDetail, type, statusTemp, dateApprove) {
        const { listLanguage, bodyAuth, footerAuth } = this.state
        let status = 'col-sm-4'

        let allowedEdit = new Date(dateApprove);
        allowedEdit.setDate(allowedEdit.getDate() + 1);
        if(statusTemp == 3 && allowedEdit > Date.now()) {
            toast.error("Can't edit Approved template before " + allowedEdit, toast.POSITION.TOP_RIGHT);
            return;
        }

        if (type === 'show') {
            status = 'hide'
            this.setState({ disabledAll: true, dismodal: true })
        } else if (type === 'edit') {
            this.setState({ disabledAll: false, disabledParent: false })
        }
        if(statusTemp == 3 || statusTemp == 4) {
            this.setState({ showButtonSaveDraf: false, statusTemplate: statusTemp});
        } else if (statusTemp == 0) {
            this.setState({ showButtonSaveDraf: true, statusTemplate: statusTemp});
        }

        if (this.props.item.get('idCategory') === '1') {
            this.setState({ isAuthentication: true });
        } else {
            this.setState({ isAuthentication: false });
        }

        let button_type = 'None'
        listLanguage.map(function (data, i) {
            if (idDetail == data.get('idTemplateDetail')) {
                let headerexample = ''
                let js = data.get('jsonRequest')
                if (parseInt(data.get('total_param_header')) > 0) {
                    let idxheader = js.indexOf("header_text")
                    let idxheaderfirst = js.indexOf("[", idxheader)
                    let idxheaderlast = js.indexOf("]", idxheaderfirst)
                    headerexample = js.substring(idxheaderfirst + 2, idxheaderlast - 1)
                    headerexample = headerexample.replaceAll(/\\/g, "")
                } else {
                    headerexample = ''
                }
                if (parseInt(data.get('total_param_body')) > 0) {
                    let idxbody = js.indexOf("body_text")
                    let idxbodyfirst = js.indexOf("[", idxbody)
                    let idxbodylast = js.indexOf("]", idxbodyfirst)
                    let bodyexample = js.substring(idxbodyfirst + 1, idxbodylast + 1)
                    bodyexample = bodyexample.replaceAll(/\\/g, "|")
                    let bodyfinal = ''
                    for (let j = 0; j < bodyexample.length; j++) {
                        if (bodyexample[j] === "|" || bodyexample[j] === "]" || bodyexample[j] == "[") {
                            continue
                        } else {
                            bodyfinal += bodyexample[j]
                        }
                    }

                    this.bodyBuild(parseInt(data.get('total_param_body')) + 1)
                    bodyfinal = bodyfinal.split(",")
                    var tempFormParamBody = this.state.formParamsBody;
                    for (let i = 0; i < bodyfinal.length; i++) {
                        tempFormParamBody = tempFormParamBody.set("param-" + (i + 1), bodyfinal[i].substring(1, bodyfinal[i].length - 1));
                    }
                    this.setState({ formParamsBody: tempFormParamBody, flagx: true })
                    this.setState({ formParamsBody2: tempFormParamBody })
                }

                let headerMessage = data.get('media_type') ? data.get('media_type').toUpperCase() : null;
                if (headerMessage === 'TEXT') {
                    this.setState({ hideMediaHeader: 'hide' })
                    this.setState({ classPreviewHeader: '' })
                    if (this.props.item.get('templateType') === 'lto') {
                        this.setState({ hideTextHeader: 'hide' })
                    } else {
                        this.setState({ hideTextHeader: '' })
                    }
                } else if ((headerMessage === 'IMAGE')) {
                    this.setState({ hideMediaHeader: '' })
                    this.setState({ hideTextHeader: 'hide' })
                    this.setState({ classPreviewHeader: 'hide' })
                } else if ((headerMessage === 'DOCUMENT')) {
                    this.setState({ hideMediaHeader: '' })
                    this.setState({ hideTextHeader: 'hide' })
                    this.setState({ classPreviewHeader: 'hide' })
                } else if ((headerMessage === 'VIDEO')) {
                    this.setState({ hideMediaHeader: '' })
                    this.setState({ hideTextHeader: 'hide' })
                    this.setState({ classPreviewHeader: 'hide' })
                } else {
                    this.setState({ hideMediaHeader: 'hide' })
                    this.setState({ hideTextHeader: 'hide' })
                }

                let varStatDisableButton = false;
                let varstatDisableButtonChange = true;
                let varStatGetSessionIdTemp = false;
                let varFileNameExamp = '';
                let varStatButtonUpload = '';

                if (data.get('type') === "hsm") {
                    headerMessage = data.get('raw_message_header')
                    if (headerMessage !== undefined) {
                        this.setState({ disabledparam: true, classPreviewHeader: '', totalcharhead: headerMessage.length })
                    } else {
                        this.setState({ disabledparam: true, classPreviewHeader: '', totalcharhead: 0 })
                    }
                    
                    if (this.props.item.get('templateType') === 'lto') {
                        this.setState({ hideTextHeader: 'hide' })
                    } else {
                        this.setState({ hideTextHeader: '' })
                    }
                } else {
                    if (data.get('idSession') !== null || data.get('idSession') !== '') {
                        varStatDisableButton = true;
                        varstatDisableButtonChange = false;
                        varStatGetSessionIdTemp = true;
                        varFileNameExamp = data.get('idUpload');
                        varStatButtonUpload = 'none';
                    }
                }
                if (type === 'show') {
                    varStatDisableButton = true;
                    varstatDisableButtonChange = true;
                }
                if (data.get('total_param_header') > 0 || data.get('total_param_body') > 0) {
                    this.setState({ disabledModal: false, flagempty: true })
                } else {
                    this.setState({ disabledModal: true, disabledparam: false })
                }

                let buttons = data.get('button') ? data.get('button') : [];
                var tinyhtmls = data.get('raw_message')
                localStorage.setItem('param', parseInt(data.get('total_param_body')))

                let bodyRawMessage = data.get('raw_message');
                let bodyPreviewFinal = this.handleParamBodyExample(data.get('raw_message'));
                let bodyExampleTemplate = this.state.formEdit.get('body-example-template');
                let bodyExamplePreview = this.state.formEdit.get('body-example-preview');
                let footerMessage = data.get('raw_message_footer');

                if (this.props.item.get('idCategory') === '1') {
                    let minutes = data.get('code_expiration_minutes')
                    tinyhtmls = bodyAuth.en;
                    bodyRawMessage = bodyAuth.en;
                    bodyPreviewFinal = bodyAuth.en.replace('{{1}}', '123456');
                    bodyExampleTemplate = bodyAuth.en;
                    bodyExamplePreview = bodyAuth.en.replace('{{1}}', '123456');
                    footerMessage = footerAuth.en + ' ' + minutes + ' minute.';

                    if (data.get('lang_code') === 'id' ) {
                        tinyhtmls = bodyAuth.id;
                        bodyRawMessage = bodyAuth.id;
                        bodyPreviewFinal = bodyAuth.id.replace('{{1}}', '123456');
                        bodyExampleTemplate = bodyAuth.id;
                        bodyExamplePreview = bodyAuth.id.replace('{{1}}', '123456');
                        footerMessage = footerAuth.id + ' ' + minutes + ' menit.';
                    }
                }

                let headerPrevFinal = ""
                if (headerMessage !== undefined) {
                    headerPrevFinal = headerMessage.replace('{{1}}', headerexample)
                }

                let carousel = []
                if (this.props.item.get('templateType') === 'carousel') {
                    if (data.get('idSession') !== null || data.get('idSession') !== '') {
                        varStatDisableButton = true;
                        varstatDisableButtonChange = false;
                        varStatGetSessionIdTemp = true;
                        varFileNameExamp = data.get('idUpload');
                        varStatButtonUpload = 'none';
                    }
                    if (data.get('templateCarousels')) {
                        let rawMessage = [];
                        data.get('templateCarousels').forEach((card, index) => {
                            let buttons = [];
                            if (card.get('button_carousel')) {
                                card.get('button_carousel').forEach((btn, idx) => {
                                    buttons.push({
                                        'button_type': btn.get('button_type'),
                                        'button_message': btn.get('button_message'),
                                        'button_value': btn.get('button_value'),
                                        'value_type': btn.get('is_dynamic') === '1' ? 'dynamic' : 'static',
                                    })
                                })
                            }
                            carousel.push(
                                {
                                    "raw_message": card.get('raw_message'),
                                    "format": card.get('format'),
                                    "param_size": card.get('param_size'),
                                    "template-buttons": buttons,
                                }
                            )
                            rawMessage.push(card.get('raw_message'));
                        })
                        this.setState({ editorHtmlCarousels: rawMessage });
                    }
                }

                if (this.props.item.get('templateType') === 'carousel' || this.props.item.get('templateType') === 'mpm' || this.props.item.get('templateType') === 'catalog') {
                    this.setState({headerTextOnly: true})
                }

                tinyhtmls = tinyhtmls.replaceAll('\n', '<br/>')

                this.setState({
                    tinyhtml: tinyhtmls,
                    paramHeader: parseInt(data.get('total_param_header')),
                    paramBody: parseInt(data.get('total_param_body')),
                    hideButtonSubmit: status,
                    hideButtonAdd: 'row no-margin-bottom hide',
                    typeDataTemp: 'edit',
                    statDisableButton: varStatDisableButton, //untuk status button upload dan change
                    statDisableButtonChange: varstatDisableButtonChange,
                    statGetSessionIdTemp: varStatGetSessionIdTemp, //untuk menyatakan kalau example telah di upload
                    fileNameExamp: varFileNameExamp, //untuk menampilkan idUpload setelah di upload
                    statButtonUpload: varStatButtonUpload, //button upload none atau tidak.
                    tempedit: headerexample,
                    totalcharfooter: footerMessage.length,
                    totalcharname: this.props.item.get('templateName').length,
                    totalchar: bodyRawMessage.length,
                    formEdit: fromJS({
                        'template-id': this.props.item.get('idTemplateMessage'),
                        'template-name': this.props.item.get('templateName'),
                        'category-id': this.props.item.get('idCategory'),
                        'language-id': data.get('lang_code'),
                        'header-id': data.get('type'),
                        'template-detail-id': data.get('idTemplateDetail'),
                        'client-id': parseInt(this.props.item.get('client_id')),
                        'division-id': parseInt(this.props.item.get('division_id')),
                        'sender-id': this.props.item.get('sender_id'),
                        'header-template': headerMessage,
                        'body-template': bodyRawMessage,
                        'header-example-template': headerexample,
                        'header-example-preview': this.state.formEdit.get('header-example-preview'),
                        'header-preview-final': headerPrevFinal,
                        'header-example-final': headerexample,
                        'body-example-template': bodyExampleTemplate,
                        'body-example-preview': bodyExamplePreview,
                        'body-preview-final': bodyPreviewFinal,
                        'footer-template': footerMessage,
                        'button-type': button_type,
                        'template-buttons': buttons,
                        'idSessionTemplate': data.get('idSession'),
                        'idUploadTemplate': data.get('idUpload'),
                        'namespace': this.props.item.get('namespace'),
                        'statusTemplate': data.get('statusTemplate'),
                        'add-security-recommendation': data.get('add_security_recommendation'),
                        'code-expiration-minutes': data.get('code_expiration_minutes'),
                        'limited-offer-text': data.get('limited_offer_text'),
                        'offer-has-expiration': data.get('offer_has_expiration') === 1 ? true : false,
                        "template-carousels": carousel,
                    }),
                })
                if (data.get('media_type') === 'text' && (data.get('raw_message_header') === "" ||
                    data.get('raw_message_header') == null || data.get('raw_message_header') === undefined ||
                    data.get('raw_message_header') === "null")) {
                    let headerId = "";
                    let headerTemplate = "";
                    if (this.props.item.get('idCategory') !== '1') {
                        headerId = data.get('type');
                        headerTemplate = headerMessage;
                    }
                    this.setState({
                        paramHeader: parseInt(data.get('total_param_header')),
                        paramBody: parseInt(data.get('total_param_body')),
                        hideButtonSubmit: status,
                        hideButtonAdd: 'row no-margin-bottom hide',
                        typeDataTemp: 'edit',
                        statDisableButton: varStatDisableButton, //untuk status button upload dan change
                        statDisableButtonChange: varstatDisableButtonChange,
                        statGetSessionIdTemp: varStatGetSessionIdTemp, //untuk menyatakan kalau example telah di upload
                        fileNameExamp: varFileNameExamp, //untuk menampilkan idUpload setelah di upload
                        statButtonUpload: varStatButtonUpload, //button upload none atau tidak.
                        tempedit: headerexample,
                        totalcharfooter: footerMessage.length,
                        totalcharname: this.props.item.get('templateName').length,
                        totalchar: bodyRawMessage.length,
                        formEdit: fromJS({
                            'template-id': this.props.item.get('idTemplateMessage'),
                            'template-name': this.props.item.get('templateName'),
                            'category-id': this.props.item.get('idCategory'),
                            'language-id': data.get('lang_code'),
                            'header-id': headerId,
                            'template-detail-id': data.get('idTemplateDetail'),
                            'client-id': parseInt(this.props.item.get('client_id')),
                            'division-id': parseInt(this.props.item.get('division_id')),
                            'sender-id': this.props.item.get('sender_id'),
                            'header-template': headerTemplate,
                            'body-template': bodyRawMessage,
                            'header-example-template': headerexample,
                            'header-example-preview': this.state.formEdit.get('header-example-preview'),
                            'header-preview-final': headerPrevFinal,
                            'header-example-final': headerexample,
                            'body-example-template': bodyExampleTemplate,
                            'body-example-preview': bodyExamplePreview,
                            'footer-template': footerMessage,
                            'template-buttons': buttons,
                            'button-type': button_type,
                            'idSessionTemplate': data.get('idSession'),
                            'idUploadTemplate': data.get('idUpload'),
                            'namespace': this.props.item.get('namespace'),
                            'add-security-recommendation': data.get('add_security_recommendation'),
                            'code-expiration-minutes': data.get('code_expiration_minutes'),
                            'limited-offer-text': data.get('limited_offer_text'),
                            'offer-has-expiration': data.get('offer_has_expiration') === 1 ? true : false,
                            "template-carousels": carousel,
                        }),
                    })
                    if (this.props.item.get('idCategory') === '1') {
                        this.setState({ hideMediaHeader: 'hide' })
                        this.setState({ hideTextHeader: 'hide' })
                        this.setState({ classPreviewHeader: 'hide' })
                    }
                }
                if (data.get('raw_message_footer') === "" || data.get('raw_message_footer') == null
                    || data.get('raw_message_footer') === "null" || data.get('raw_message_footer') === undefined) {
                    if (data.get('media_type') === 'text' && (data.get('raw_message_header') === "" ||
                        data.get('raw_message_header') == null || data.get('raw_message_header') === undefined ||
                        data.get('raw_message_header') === "null")) {
                        let headerId = "";
                        let headerTemplate = "";
                        if (this.props.item.get('idCategory') !== '1') {
                            headerId = data.get('type');
                            headerTemplate = headerMessage;
                        }
                        this.setState({
                            paramHeader: parseInt(data.get('total_param_header')),
                            paramBody: parseInt(data.get('total_param_body')),
                            hideButtonSubmit: status,
                            hideButtonAdd: 'row no-margin-bottom hide',
                            typeDataTemp: 'edit',
                            statDisableButton: varStatDisableButton, //untuk status button upload dan change
                            statDisableButtonChange: varstatDisableButtonChange,
                            statGetSessionIdTemp: varStatGetSessionIdTemp, //untuk menyatakan kalau example telah di upload
                            fileNameExamp: varFileNameExamp, //untuk menampilkan idUpload setelah di upload
                            statButtonUpload: varStatButtonUpload, //button upload none atau tidak.
                            tempedit: headerexample,
                            totalcharfooter: footerMessage.length,
                            totalcharname: this.props.item.get('templateName').length,
                            totalchar: bodyRawMessage.length,
                            formEdit: fromJS({
                                'template-id': this.props.item.get('idTemplateMessage'),
                                'template-name': this.props.item.get('templateName'),
                                'category-id': this.props.item.get('idCategory'),
                                'language-id': data.get('lang_code'),
                                'header-id': headerId,
                                'template-detail-id': data.get('idTemplateDetail'),
                                'client-id': parseInt(this.props.item.get('client_id')),
                                'division-id': parseInt(this.props.item.get('division_id')),
                                'sender-id': this.props.item.get('sender_id'),
                                'header-template': headerTemplate,
                                'body-template': bodyRawMessage,
                                'header-example-template': headerexample,
                                'header-example-preview': this.state.formEdit.get('header-example-preview'),
                                'header-preview-final': headerPrevFinal,
                                'header-example-final': headerexample,
                                'body-example-template': bodyExampleTemplate,
                                'body-example-preview': bodyExamplePreview,
                                'footer-template': footerMessage,
                                'template-buttons': buttons,
                                'button-type': button_type,
                                'idSessionTemplate': data.get('idSession'),
                                'idUploadTemplate': data.get('idUpload'),
                                'namespace': this.props.item.get('namespace'),
                                'add-security-recommendation': data.get('add_security_recommendation'),
                                'code-expiration-minutes': data.get('code_expiration_minutes'),
                                'limited-offer-text': data.get('limited_offer_text'),
                                'offer-has-expiration': data.get('offer_has_expiration') === 1 ? true : false,
                                "template-carousels": carousel,
                            }),
                        })
                        if (this.props.item.get('idCategory') === '1') {
                            this.setState({ hideMediaHeader: 'hide' })
                            this.setState({ hideTextHeader: 'hide' })
                            this.setState({ classPreviewHeader: 'hide' })
                        }
                    } else {
                        this.setState({
                            paramHeader: parseInt(data.get('total_param_header')),
                            paramBody: parseInt(data.get('total_param_body')),
                            hideButtonSubmit: status,
                            hideButtonAdd: 'row no-margin-bottom hide',
                            typeDataTemp: 'edit',
                            statDisableButton: varStatDisableButton, //untuk status button upload dan change
                            statDisableButtonChange: varstatDisableButtonChange,
                            statGetSessionIdTemp: varStatGetSessionIdTemp, //untuk menyatakan kalau example telah di upload
                            fileNameExamp: varFileNameExamp, //untuk menampilkan idUpload setelah di upload
                            statButtonUpload: varStatButtonUpload, //button upload none atau tidak.
                            tempedit: headerexample,
                            totalcharfooter: footerMessage.length,
                            totalcharname: this.props.item.get('templateName').length,
                            totalchar: bodyRawMessage.length,
                            formEdit: fromJS({
                                'template-id': this.props.item.get('idTemplateMessage'),
                                'template-name': this.props.item.get('templateName'),
                                'category-id': this.props.item.get('idCategory'),
                                'language-id': data.get('lang_code'),
                                'header-id': data.get('type'),
                                'template-detail-id': data.get('idTemplateDetail'),
                                'client-id': parseInt(this.props.item.get('client_id')),
                                'division-id': parseInt(this.props.item.get('division_id')),
                                'sender-id': this.props.item.get('sender_id'),
                                'header-template': headerMessage,
                                'body-template': bodyRawMessage,
                                'header-example-template': headerexample,
                                'header-example-preview': this.state.formEdit.get('header-example-preview'),
                                'header-preview-final': headerPrevFinal,
                                'header-example-final': headerexample,
                                'body-example-template': bodyExampleTemplate,
                                'body-example-preview': bodyExamplePreview,
                                'footer-template': "",
                                'template-buttons': buttons,
                                'button-type': button_type,
                                'idSessionTemplate': data.get('idSession'),
                                'idUploadTemplate': data.get('idUpload'),
                                'namespace': this.props.item.get('namespace'),
                                'add-security-recommendation': data.get('add_security_recommendation'),
                                'code-expiration-minutes': data.get('code_expiration_minutes'),
                                'limited-offer-text': data.get('limited_offer_text'),
                                'offer-has-expiration': data.get('offer_has_expiration') === 1 ? true : false,
                                "template-carousels": carousel,
                            }),
                        })
                    }

                }
            }

        }.bind(this));
        this.setState({
            statusDoc: 'addLang',
            form: fromJS({
                'client-id': parseInt(this.props.item.get('client_id'), 10),
                'division-id': parseInt(this.props.item.get('division_id'), 10),
                'sender-id': this.props.item.get('sender_id'),
                'template-id': this.props.item.get('idTemplateMessage'),
                'template-name': this.props.item.get('templateName'),
                'template-type': this.props.item.get('templateType'),
                'category-id': this.props.item.get('idCategory'),
                'availableChange': this.props.item.get('availableChange'),
                'namespace': this.props.item.get('namespace'),
            }),
        })


    }

    componentWillMount() {
        this.props.actionGetNameSpace(this.props.item.get('client_id'));
        var varActionId = "";
        var dataAkses = null;

        setTimeout(() => {
            dataAkses = this.props.accessmoduleaction;
            if (dataAkses) {
                varActionId = dataAkses.get("action-id");
                this.setState({ actionId: varActionId });
                if(varActionId == 5){
                    this.props.actionFetchSender(ClientId);
                    this.props.actionFetchAllDivision(ClientId);
                }
            }
        }, 3000);

        if (this.props.item !== null || this.props.item !== undefined) {
            var data = fromJS({});
            data = this.props.item.get('messageDetail')
            this.setState({
                form: fromJS({
                    'client-id': parseInt(this.props.item.get('client_id'), 10),
                    'division-id': parseInt(this.props.item.get('division_id'), 10),
                    'sender-id': this.props.item.get('sender_id'),
                    'template-id': this.props.item.get('idTemplateMessage'),
                    'template-name': this.props.item.get('templateName'),
                    'template-type': this.props.item.get('templateType'),
                    'category-id': this.props.item.get('idCategory'),
                    'namespace': this.props.item.get('namespace'),
                    'availableChange': this.props.item.get('availableChange'),
                }),
                listLanguage: data,
                loadded: true,
            })
        }
    }

    handleMessageAuthType = (form, categoryId, language, minute) => {
        if (categoryId !== 1) {
            return form;
        }

        let formVal = form;
        let body = this.state.bodyAuth.en;
        let footer = this.state.footerAuth.en + ' ' + minute + ' minute.';

        if (language === 'id') {
            body = this.state.bodyAuth.id
            footer = this.state.footerAuth.id+ ' ' + minute + ' menit.';
        }

        this.setState({ tinyhtml: body})

        formVal = formVal.set('body-template', body)
        formVal = formVal.set('body-preview-final', body.replace('{{1}}', '123456'))
        formVal = formVal.set('footer-template', footer)

        return formVal;
    }

    handleAddLanguage() {
        let idCategory = this.props.item.get('idCategory');
        let bodyRawMessage = '';
        let bodyPreviewFinal = '';
        let footerMessage = '';

        if (idCategory === '1') {
            bodyRawMessage = '*{{1}}* is your verification code. For your security, do not share this code.';
            bodyPreviewFinal = bodyRawMessage.replace('{{1}}', '123456');
            footerMessage = 'This code expires in 0 minute.';
        }

        let headerId = '';
        let hideTextHeader = 'hide';
        if (this.props.item.get('templateType') === 'carousel' || this.props.item.get('templateType') === 'mpm' || this.props.item.get('templateType') === 'catalog') {
            headerId = 'hsm';
            hideTextHeader = '';
            this.setState({
                headerTextOnly: true,
                classPreviewHeader: ''
            });
        }
        
        this.setState({
            statusDoc: 'addLang',
            disabledAll: false,
            disabledModal: true,
            disabledParent: true,
            statDisableButton: false,
            hideButtonAdd: 'row no-margin-bottom hide',
            isAuthentication: idCategory === '1' ? true : false,
            hideMediaHeader: 'hide',
            hideTextHeader: hideTextHeader,
            paramHeader: 0,
            paramBody: 0,
            showButtonSaveDraf: true,
            typeDataTemp: 'add',
            tinyhtml: bodyRawMessage,
            formParamsBody: fromJS({}),
            formParamsBody2: fromJS({}),
            formParamsBody3: fromJS({}),
            formEdit: fromJS({
                'client-id': parseInt(this.props.item.get('client_id'), 10),
                'division-id': parseInt(this.props.item.get('division_id'), 10),
                'sender-id': this.props.item.get('sender_id'),
                'template-id': this.props.item.get('idTemplateMessage'),
                'template-name': this.props.item.get('templateName'),
                'category-id': idCategory,
                'namespace': this.props.item.get('namespace'),
                'body-template': bodyRawMessage,
                'header-id': headerId,
                'header-template': '',
                'header-example-template': '',
                'header-example-preview': '',
                'header-preview-final': '',
                'header-example-final': '',
                'body-example-template': '',
                'body-example-preview': '',
                'body-preview-final': bodyPreviewFinal,
                'template-buttons': [],
                'footer-template': footerMessage,
                'add-security-recommendation': null,
                'code-expiration-minutes': 0,
                'limited-offer-text': '',
                'offer-has-expiration': false,
                "template-carousels": [
                    {
                        "raw_message": "",
                        "format": "", // image / video
                        "param_size": 0,
                        "template-buttons": [
                            {
                                'button_type': '',
                                'button_message': '',
                                'button_value': '',
                                'value_type': '',
                            }
                        ],
                    }
                ],
            }),
            form: fromJS({
                'client-id': parseInt(this.props.item.get('client_id'), 10),
                'division-id': parseInt(this.props.item.get('division_id'), 10),
                'sender-id': this.props.item.get('sender_id'),
                'template-id': this.props.item.get('idTemplateMessage'),
                'template-name': this.props.item.get('templateName'),
                'template-type': this.props.item.get('templateType'),
                'category-id': idCategory,
                'namespace': this.props.item.get('namespace'),
                'availableChange': this.props.item.get('availableChange'),
            }),
        })
    }

    handleListLanguage(listLanguage) {
        let element = ''
        let contents = []
        {
            listLanguage.map((data, i) =>
                contents.push({
                    'lang_code': data.get('lang_code'),
                    'type': data.get('type'),
                    'idTemplateDetail': data.get('idTemplateDetail'),
                    'statusTemplate': data.get('statusTemplate'),
                    'availableChange': data.get('availableChange'),
                    'dateApprove': data.get('dateApprove')
                })
            )
        }
        return contents

    }

    handleModal() {
        let formVal = this.state.formEdit
        let textHeader = formVal.get('header-template')
        let textHeaderReplace = ''
        let stringParam = ''
        for (let i = 0; i < textHeader.length; i++) {
            if (textHeader[i] == "{" && textHeader[i + 1] == "{") {
                stringParam = (textHeader.substring(i, i + 5))
                if (this.state.formEdit.get('header-example-template') !== '' || this.state.formEdit.get('header-example-template') !== "") {
                    textHeaderReplace = textHeader.replace(stringParam, this.state.formEdit.get('header-example-template'))
                } else {
                    textHeaderReplace = textHeader.replace(stringParam, "")
                }
            }
        }


        let stringParam2 = ''
        let stringIndex = ''
        let stringcheck = ''
        let index = 0
        let textbody = this.state.formEdit.get('body-template')
        let count = 1
        let arrnum = []
        for (let i = 0; i < textbody.length; i++) {
            if (textbody[i] == "{" && textbody[i + 1] == "{") {
                index = textbody.indexOf("}", i)
                stringIndex = textbody.substring(i, index + 2)
                stringcheck = stringIndex.substring(2, stringIndex.length - 2)
                stringParam2 = (textbody.substring(i, index + 2))
                if (this.state.formParamsBody.get("param-" + stringcheck) !== undefined) {
                    textbody = textbody.replace(stringParam2, " " + this.state.formParamsBody.get("param-" + stringcheck) + " ")
                } else {
                    textbody = textbody.replace(stringParam2, " ")
                }
                if (arrnum.includes(stringcheck)) {

                } else {
                    arrnum.push(stringcheck)
                    count += 1
                }
            }
        }
        if (this.state.paramHeader > 0) {
            formVal = formVal.set('header-example-preview', textHeaderReplace);
        } else {
            formVal = formVal.set('header-example-preview', textHeader);
        }
        formVal = formVal.set('body-example-preview', textbody);
        formVal = formVal.set('header-preview-final', textHeaderReplace);
        this.setState({ formEdit: formVal })
        this.setState({ modal: true })
        this.bodyBuild(count)
    }
    handleCancelModal() {
        let formVal = this.state.formEdit
        let formval2 = this.state.formParamsBody
        let formval3 = this.state.formParamsBody2
        let formval4 = this.state.formParamsBody3
        let artep = this.state.arrayTemp
        if (formVal.get('header-example-final') !== "") {
            formVal = formVal.set('header-example-template', formVal.get('header-example-final'));
        } else {
            formVal = formVal.set('header-example-template', "");
        }

        for (let i = 0; i < artep.length; i++) {
            let a = formval2.get("param-" + artep[i])
            if (formval2.get("param-" + artep[i]) !== undefined || formval2.get("param-" + artep[i] !== "")) {
                formval2 = formval2.set('param-' + artep[i], "")

            }
            if (formval2.get("param-" + artep[i]) == "") {
                formval2 = formval2.remove("param-" + artep[i])
            }
        }
        formval2 = formval4
        if (formval2.size == 0) {
            formval2 = formval3
            this.setState({ parameterBody: this.state.parameterBody2 })
        }
        this.setState({ formEdit: formVal, parameterBody: this.state.parameterBody2, formParamsBody: formval2, counterParam: formval2.size })
        this.setState({ modal: false, flagempty: false })
    }

    handlesubmitModal() {
        const { formParamsBody, formEdit, parameterBody, paramUrlDynamic, paramButton } = this.state
        let formVal = this.state.formEdit
        formVal = formVal.set('header-preview-final', formVal.get('header-example-preview'));
        formVal = formVal.set('body-preview-final', formVal.get('body-example-preview'));
        formVal = formVal.set('header-example-final', formVal.get('header-example-template'));
        for (let i = 0; i < this.state.counterParam; i++) {
            if (formParamsBody.get("param-" + (i + 1)) == '') {
                let string = "parameter " + (i + 1)
                toast.error(string + " cannot be empty", toast.POSITION.TOP_RIGHT);
                return false
            }
        }
        if (this.state.paramHeader > 0) {
            if (formEdit.get("header-example-template") == '') {
                toast.error("header parameter cannot be empty", toast.POSITION.TOP_RIGHT);
                return false
            }
        }
        if (this.state.paramButton > 0) {
            if (this.state.paramUrlDynamic === ''){
                toast.error("button parameter cannot be empty", toast.POSITION.TOP_RIGHT);
                return false
            }
        }
        this.setState({
            formEdit: formVal,
            formParamsBody3: formParamsBody,
            parameterBody3: parameterBody,
            arrayTemp: []
        })
        this.setState({ modal: false, flagempty: true, hideror: 'hide' })
    }
    handleChangeParam(field, value) {
        let stringParam = ''
        var formVal = this.state.formParamsBody;
        var formValform = this.state.formEdit;
        formVal = formVal.set(field, value);
        this.setState({ formParamsBody: formVal })
        let str = ''
        let stringIndex = ''
        let stringcheck = ''
        let index = 0
        let textbody = this.state.formEdit.get('body-template')
        let count = 0
        for (let i = 0; i < textbody.length; i++) {
            if (textbody[i] == "{" && textbody[i + 1] == "{") {
                count += 1
                index = textbody.indexOf("}", i)
                stringIndex = textbody.substring(i, index + 2)
                stringcheck = stringIndex.substring(2, stringIndex.length - 2)
                str = formVal.get("param-" + count)
                stringParam = (textbody.substring(i, index + 2))
                textbody = textbody.replace(stringParam, " " + str + " ")

            }
        }

        formValform = formValform.set('body-example-preview', textbody);
        this.setState({ formEdit: formValform })
    }
    bodyBuild(count) {
        var arrtem = this.state.arrayTemp
        var xparams = this.state.parameterBody;
        var formParams = this.state.formParamsBody;
        var xflag = this.state.flagx
        for (let i = 0; i < count - 1; i++) {
            const id = `param-${i + 1}`
            const lbl = `parameter ${i + 1}`
            if (this.state.formParamsBody.get("param-" + (i + 1)) !== undefined) continue
            xparams = xparams.set(i + 1, fromJS({ 'id': id, 'label': lbl }))
            formParams = formParams.set(id, '')
            arrtem.push(i + 1)
        }

        if (xflag == true) {

            for (let i = 0; i < formParams.size; i++) {
                const id = `param-${i + 1}`
                const lbl = `parameter ${i + 1}`
                xparams = xparams.set(i + 1, fromJS({ 'id': id, 'label': lbl }))
            }
            this.setState({ parameterBody2: xparams, flagx: false });

        }
        if (formParams.size < xparams.size || (count - 1) < xparams.size || formParams.size > xparams.size) {
            let sizeparam = xparams.size
            for (let j = (count - 1); j <= sizeparam; j++) {
                formParams = formParams.remove("param-" + (j + 1))
                xparams = xparams.remove(j + 1)
            }
        }
        this.setState({ parameterBody: xparams, formParamsBody: formParams, counterParam: (count - 1), arrayTemp: arrtem });
    }
    renderParamBody() {
        const { formParamsBody, parameterBody, errors } = this.state
        return parameterBody.toList().map((item) => {
            const field = item.get('id')
            const lbl = item.get('label')
            return (
                <div className="col-sm-12 ">
                    <TextInputField className="form-control-text"
                        field={field}
                        value={formParamsBody.get(field)}
                        onChange={(field, value) => this.handleChangeParam(field, value)}
                        placeholder={lbl}
                        hasError={errors.has(field)}
                    />
                </div>
            )
        })

    }

    renderModal() {
        const { formEdit, errors, disabledAll, modal } = this.state;
        let hidehead = ''
        let hidebody = ''
        let hidebox = ''
        if (formEdit.get('header-template') !== 'IMAGE' && formEdit.get('header-template') !== 'VIDEO' &&
            formEdit.get('header-template') !== 'DOCUMENT' && formEdit.get('header-template') !== "") {
            hidehead = ''
        } else {
            hidehead = 'hide'
        }
        if (this.state.paramHeader > 0) {
            hidebox = ''
        } else {
            hidebox = 'hide'
        }
        if (formEdit.get('body-template') == '' || formEdit.get('body-template') == "") {
            hidebody = 'hide'
        } else {
            hidebody = ''
        }
        return (
            <Modal
                show={modal} dialogClassName="custom-modal" >
                <Modal.Header>
                    <Modal.Title>Add Example Template</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="col-md-8  nopadding">
                        <div className="card noborder-left noborder-right card_noborderradius">
                            <div className="body msg_card_body template-body" ref={(el) => { this.messagesEnd = el; }}>
                                <div className='row no-margin-bottom col-sm-12'>
                                    <p className='col-sm-12 justify-text'>To help us understang what kind of message you want to send you have the
                                        option to provide specific content examples for your template.</p>
                                    <p className='col-sm-12 justify-text'>You can add a
                                        sample template for one or all languages you are submitting</p>
                                    <span className={`col-sm-12 font-weight-bold ${hidehead}`}>
                                        Header<br />
                                    </span>

                                    <p className={`col-sm-12 ${hidehead}`}>{formEdit.get('header-template')}</p>
                                    <div className={`col-sm-12 ${hidebox}`}>
                                        <TextInputField
                                            className="form-control-text"
                                            field={'header-example-template'}
                                            value={formEdit.get('header-example-template')}
                                            onChange={(field, value) => this.handleChangeEdit(field, value)}
                                            placeholder="Header"
                                            disabled={disabledAll}
                                            hasError={errors.has('header-example-template')}
                                        />
                                    </div>
                                    <span className={`col-sm-12 font-weight-bold ${hidebody}`}>
                                        Body<br />
                                    </span>
                                    <p className={`col-sm-12${hidebody}`}>{formEdit.get('body-template')}</p>
                                    {
                                        this.renderParamBody()
                                    }
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="col-md-4 nopadding">
                        <PreviewMessage
                            rawMessage={this.state.isAuthentication ? null : formEdit.get('body-example-preview')}
                            textHeader={this.state.isAuthentication ? null : formEdit.get('header-example-preview')}
                            textFooter={this.state.isAuthentication ? null : formEdit.get('footer-template')}
                            type={this.state.isAuthentication ? null : formEdit.get('header-id') == 'hsm' ? 'text' : 'media'}
                            mediaType={this.state.isAuthentication ? null : formEdit.get('header-template') ? formEdit.get('header-template').toLowerCase() : ''}
                        />
                    </div>


                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-primary" onClick={this.handlesubmitModal}>Done</button>
                    <button type="button" className="btn btn-secondary" onClick={this.handleCancelModal}>Cancel</button>
                </Modal.Footer>
            </Modal>

        )
    }
    renderAddLanguage() {
        const { form, formEdit, disabledAll } = this.state;

        let disabledLanguage = false
        if (formEdit.get('statusTemplate') > 0) {
            disabledLanguage = true
        }

        return (
            <div className="card marginempty">
                <div className="col-sm-12 paddingempty">
                    <span className="col-sm-2">Language</span>
                    <div className="col-sm-10">
                        <ComboboxInput
                            field='language-id'
                            value={formEdit.get('language-id')}
                            options={fromJS({
                                'source': this.props.languageTemplate,
                                'value': 'lang_code',
                                'label': 'language'
                            })}
                            onChange={(field, value, label) => this.handleChangeEdit(field, value, label)}
                            placeholder="Language"
                            disabled={disabledLanguage || disabledAll}
                        />
                    </div>
                </div>
            </div>
        )
    }

    handleCancel() {
        this.setState({
            statusDoc: 'viewList',
            hideButtonAdd: 'row no-margin-bottom',
            disabledAll: true
        });
    }

    handleBack() {
        this.props.handleCancelForm(false);
    }

    showContent() {
        let statusDoc = this.state.statusDoc
        const { form, tinyhtml, paramBody, hideButtonSubmit, disabledModal, showButtonSaveDraf, hideror, disabledAll, errors, listLanguage, templateHeader, formEdit, hideMediaHeader, headerMediaType, hideTextHeader, isAuthentication, limitedOfferTextLength, editorHtmlCarousels, headerTextOnly, listFlow } = this.state;
        let array = this.handleListLanguage(listLanguage)
        const detailLto = {
            id: {
                limitedOfferText: formEdit.get('limited-offer-text'),
                offerHasExpiration: formEdit.get('offer-has-expiration'),
                offerTimeExpiredText: 'Penawaran berakhir pada <EXPIRATION TIME>',
                codeText: 'Kode <OFFER_CODE>',
            },
            en: {
                limitedOfferText: formEdit.get('limited-offer-text'),
                offerHasExpiration: formEdit.get('offer-has-expiration'),
                offerTimeExpiredText: 'Offer ends on <EXPIRATION TIME>',
                codeText: 'Code <OFFER_CODE>',
            }
        }
        const ltoPreview = formEdit.get("language-id") === 'id' ? detailLto.id : detailLto.en;
        const hideHeader = isAuthentication || form.get("template-type") === 'carousel' || form.get("template-type") === 'catalog';

        if (statusDoc === 'viewList') {
            return (
                <div className="clearfix">
                    <div className="card-noborder">
                        <h4>
                            List Language
                        </h4>
                    </div>

                    <div className="clearfix">
                        <div>
                            {array.map((data, i) => (
                                <div className="col-sm-3 card row">
                                    <p>Language Code : {data.lang_code}</p>
                                    <p>Type : {data.type}</p>
                                    <button className='btn btn-sm btn-success'
                                        onClick={() => this.handleEditedLanguage(data.idTemplateDetail, 'show', data.statusTemplate, null)}
                                    >
                                        Show Detail
                                    </button>

                                    <button
                                        className={ data.availableChange ? 'btn btn-sm btn-success' : 'hide'}
                                        onClick={() => this.handleEditedLanguage(data.idTemplateDetail, 'edit', data.statusTemplate, data.dateApprove)}
                                    >
                                        Edit
                                    </button>
                                </div>

                            ))}
                        </div>
                    </div>
                </div>
            )
        } else if (statusDoc === 'addLang') {

            return (
                <div id="chat-container">
                    <div className="col-md-12 nopadding noheight">
                        {this.renderAddLanguage()}
                    </div>
                    <div className="col-md-12 nopadding">
                        <div className="col-md-9 nopadding">
                            <div className="card noborder-left noborder-right card_noborderradius">
                                <div className={`header`}>

                                    <h5>Add Template</h5>
                                    <button type="button"
                                        className={`btn btn-primary btn-md ${isAuthentication ? 'hide' : ''}`}
                                        onClick={this.handleModal}
                                        disabled={disabledAll || disabledModal}
                                    >
                                        {"Add Sample"}
                                    </button>
                                    <span className={`col-md-12 nopadding error ${hideror}`}>Please add sample for each parameter</span>
                                    {this.renderModal()}
                                </div>
                                <div className="body msg_card_body template-body" ref={(el) => { this.messagesEnd = el; }}>
                                    <div className={`row no-margin-bottom col-sm-12 ${hideHeader ? 'hide' : ''}`}>
                                        <span className='col-sm-12 font-weight-bold'>
                                            Header<br />
                                            <span style={{fontSize: '10pt'}}>Add a title or choose which type of media you'll use for this header.</span>
                                        </span>
                                        <div className="col-sm-4">
                                            <ComboboxInput
                                                field='header-id'
                                                value={formEdit.get('header-id')}
                                                options={fromJS({
                                                    'source': templateHeader,
                                                    'value': 'header-id',
                                                    'label': 'header-name'
                                                })}
                                                onChange={(field, value, label) => this.handleChangeEdit(field, value, label)}
                                                placeholder="Header"
                                                disabled={this.state.statDisableButton || disabledAll || headerTextOnly}
                                            />
                                        </div>
                                        <div className={`col-sm-7 ${hideMediaHeader}`}>
                                            <ComboboxInput
                                                field='header-template'
                                                value={formEdit.get('header-template')}
                                                options={fromJS({
                                                    'source': headerMediaType,
                                                    'value': 'header-media-id',
                                                    'label': 'header-media-id'
                                                })}
                                                onChange={(field, value, label) => this.handleChangeEdit(field, value, label)}
                                                placeholder="Media"
                                                disabled={this.state.statDisableButton || disabledAll}
                                            />
                                        </div>
                                        <div className={`col-sm-7 ${hideTextHeader}`}>
                                            <TextInputField
                                                className="form-control-text"
                                                field={'header-template'}
                                                value={formEdit.get('header-template')}
                                                onChange={(field, value) => this.handleChangeEdit(field, value)}
                                                placeholder="Header"
                                                disabled={disabledAll}
                                                hasError={errors.has('header-template')}
                                            />
                                        </div>
                                        <div className={`col-sm-1 headchar ${hideTextHeader}`}>
                                            {this.state.totalcharhead + "/60"}
                                        </div>
                                        <div className={`col-sm-1 ${hideTextHeader}`}>
                                            <button type="button"
                                                className="btn btn-primary btn-sm"
                                                onClick={this.handleParamHeader}
                                                disabled={this.state.disabledparam || disabledAll}>
                                                {'{{}}'}
                                            </button>
                                        </div>


                                        <div className={`col-sm-12 ${hideMediaHeader}`}>
                                            <span className="col-sm-4">Example File</span>
                                            <div className="col-sm-7">
                                                <input className="form-control"
                                                    type="file"
                                                    name="file"
                                                    disabled={this.state.statDisableButton}
                                                    style={{ display: this.state.statButtonUpload }}
                                                    key={formEdit.get('file-key')}
                                                    onClick={e => (e.target.value = null)}
                                                    onChange={this.handleOnFileChanged}
                                                />
                                                <p>{this.state.fileNameExamp}</p>
                                            </div>
                                        </div>
                                        <div className={`col-sm-12 ${hideMediaHeader}`}>
                                            <button type="button"
                                                className="btn btn-info mr-2"
                                                disabled={this.state.statDisableButton}
                                                onClick={this.handleUploadFile}>
                                                Upload
                                            </button>
                                            <button type="button"
                                                className="btn btn-danger"
                                                disabled={this.state.statDisableButtonChange}
                                                onClick={this.handleCancelFile}>
                                                Change
                                            </button>
                                        </div>
                                    </div>

                                    <div className='row no-margin-bottom col-sm-12'>
                                        <span className='col-sm-12 no-margin-bottom font-weight-bold'>
                                            Body<br />
                                            <span className={`${isAuthentication ? 'hide' : ''}`}>
                                                <span style={{fontSize: '10pt'}}>Enter the text for your message in the language you've selected.</span>
                                                <Tooltip title={
                                                    <React.Fragment>
                                                        <Typography variant="h6" color="inherit">Maximum 2 times concecutively for spacing 'ENTER'</Typography>
                                                    </React.Fragment>
                                                } >
                                                    <button><i className='small-icon' ><InfoIcon /></i></button>
                                                </Tooltip>
                                            </span>
                                        </span>
                                        <div className={`col-sm-12`}>
                                            <div>
                                                <EditorMessage
                                                    value={tinyhtml}
                                                    lengthValue={
                                                        formEdit.get('body-template')
                                                        ? formEdit.get('body-template').length
                                                        : 0
                                                    }
                                                    onChange={this.onEditorChange}
                                                    setParamSize={this.setParamSize}
                                                    paramSize={paramBody}
                                                    disabled={disabledAll || isAuthentication}
                                                    placeholder={'Input message here...'}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {form.get('template-type') !== "lto" && form.get('template-type') !== "carousel" && (
                                        <div className={`row no-margin-bottom col-sm-12`}>
                                            <span className='col-sm-12 no-margin-bottom font-weight-bold'>
                                                Footer<br />
                                            </span>
                                            <div className={`col-sm-12`}>
                                                <span style={{fontSize: '10pt', fontWeight: 'bold'}}> Add a short line of text to the bottom of your message template.</span>
                                                <TextInputField
                                                    className="form-control"
                                                    field={'footer-template'}
                                                    value={formEdit.get('footer-template')}
                                                    onChange={(field, value) => this.handleChangeEdit(field, value)}
                                                    placeholder="Footer"
                                                    disabled={disabledAll || isAuthentication}
                                                    hasError={errors.has('footer-template')}
                                                />
                                                <div className={`col-sm-1 footerchar `}>
                                                    {isAuthentication ? formEdit.get('footer-template').length + "/60" : this.state.totalcharfooter + "/60"}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {form.get('template-type') === "lto" && (
                                        <>
                                            <div className="row no-margin-bottom col-sm-12">
                                                <p className="col-sm-12 mb-0">
                                                    <span className="font-weight-bold">
                                                        Limited-time offer
                                                    </span>
                                                    {!disabledAll && (
                                                        <React.Fragment>
                                                            <br />
                                                            <span className="font-weight-light">
                                                                Add a short line of text
                                                                for detail promo.
                                                            </span>
                                                        </React.Fragment>
                                                    )}
                                                </p>
                                                <div className={`col-sm-12`}>
                                                    <TextInputField
                                                        className="form-control pr-5"
                                                        field={"limited-offer-text"}
                                                        value={formEdit.get(
                                                            "limited-offer-text"
                                                        )}
                                                        onChange={(field, value) =>
                                                            this.handleChangeEdit(
                                                                field,
                                                                value
                                                            )
                                                        }
                                                        maxLength={limitedOfferTextLength}
                                                        placeholder={
                                                            disabledAll
                                                                ? ""
                                                                : "Input Limited-time offer text here..."
                                                        }
                                                        disabled={disabledAll}
                                                        hasError={errors.has(
                                                            "limited-offer-text"
                                                        )}
                                                    />
                                                    <span className="length-footer">
                                                        {
                                                            formEdit.get(
                                                                "limited-offer-text"
                                                            ).length
                                                        }
                                                        /{limitedOfferTextLength}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-sm-12">
                                                <CheckBoxInputField className="form-control"
                                                    field={"offer-has-expiration"}
                                                    checked={formEdit.get('offer-has-expiration')}
                                                    onChange={(field, value) => this.handleChangeEdit(field, value)}
                                                    label="Has expiration"
                                                />
                                            </div>
                                        </>
                                    )}
                                    <div className={`col-sm-12 pt-3 ${isAuthentication ? '' : 'hide'}`}>
                                        <CheckBoxInputField className="form-control"
                                            field={"add-security-recommendation"}
                                            checked={formEdit.get('add-security-recommendation') || false}
                                            onChange={(field, value) => this.handleChangeEdit(field, value)}
                                            label="Add Security Recommendation"
                                            disabled={disabledAll}
                                        />
                                    </div>
                                    <div className={`row no-margin-bottom col-sm-12 ${isAuthentication ? '' : 'hide'}`}>
                                        <div className={`col-sm-3`}>
                                            <span>Code Expirations</span>
                                        </div>
                                        <div className={`col-sm-3`}>
                                            <TextInputField
                                                number
                                                className="form-control"
                                                field={'code-expiration-minutes'}
                                                value={formEdit.get('code-expiration-minutes')}
                                                onChange={(field, value) => this.handleChangeEdit(field, value)}
                                                placeholder="1-90"
                                                disabled={disabledAll}
                                                hasError={errors.has('code-expiration-minutes')}
                                            />
                                        </div>
                                        <div className={`col-sm-3 mt-3 ml-0`}>
                                            <Tooltip title={
                                                <React.Fragment>
                                                    <Typography variant="h6" color="inherit">Indicates number of minutes the password or code is valid. Minimum 1, maximum 90.</Typography>
                                                </React.Fragment>
                                            } >
                                                <button><i className='small-icon' ><InfoIcon /></i></button>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    {form.get("template-type") !== "carousel" ? (
                                        <ButtonManager
                                            categoryId={form.get('category-id')}
                                            templateType={form.get('template-type')}
                                            disabled={disabledAll}
                                            items={formEdit.get('template-buttons')}
                                            listFlow={listFlow}
                                            onChange={(field, value) => this.handleChangeEdit(field, value)}
                                            hasError={errors.has('template-buttons')}
                                        />
                                    ) : (
                                        <div className="input-carousel-wrapper">
                                            {formEdit.get("template-carousels").map((card, index) => (
                                                <CardCarousel
                                                    key={`card-carousel-${index+1}`}
                                                    disabled={disabledAll}
                                                    editorHtmlCarousels={editorHtmlCarousels}
                                                    index={index}
                                                    errors={errors}
                                                    handleChange={this.handleChangeInCardCarousel}
                                                    onEditorChange={this.onEditorCardCarouselChange}
                                                    setParamSize={this.setParamSizeCardCarousel}
                                                    buttons={card.get("template-buttons")}
                                                    paramSize={card.get("param_size")}
                                                    rawMessage={card.get("raw_message")}
                                                    format={card.get("format")}
                                                    categoryId={form.get("category-id")}
                                                    statDisableButton={this.state.statDisableButton}
                                                    statButtonUpload={this.state.statButtonUpload}
                                                    fileKey={formEdit.get('file-key')}
                                                    fileNameExamp={this.state.fileNameExamp}
                                                    handleOnFileChanged={this.handleOnFileChanged}
                                                    handleUploadFile={this.handleUploadFile}
                                                    handleCancelFile={this.handleCancelFile}
                                                    onRemove={formEdit.get("template-carousels").size > 1 && this.deleteCardCarousel}
                                                    onAddMoreCard={formEdit.get("template-carousels").size === index+1 && formEdit.get("template-carousels").size < 10 ? this.addMoreCardCarousel : null}
                                                />
                                            ))}
                                        </div>
                                    )}
                                    <div className="row no-margin-bottom">
                                        <div className={`col-sm-4 ${hideButtonSubmit}`}>
                                            <button type="button"
                                                className="btn btn-wide btn-success"
                                                onClick={this.handleSubmit}>
                                                Submit
                                            </button>
                                        </div>
                                        <div className={`col-sm-4 ${hideButtonSubmit}` + (showButtonSaveDraf ? '' : ' hide')}>
                                            <button type="button"
                                                className="btn btn-wide btn-warning"
                                                onClick={this.handleSaveDraft}>
                                                Save To Draft
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row no-margin-bottom">
                                        <div className="col-sm-4">
                                            <button type="button"
                                                className="btn btn-wide btn-danger"
                                                onClick={this.handleCancel}>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                        <div className="col-md-3 nopadding">
                            <PreviewMessage
                                textHeader={this.state.isAuthentication ? null : formEdit.get('header-preview-final')}
                                rawMessage={formEdit.get('body-preview-final')}
                                textFooter={formEdit.get('footer-template')}
                                type={this.state.isAuthentication ? null : formEdit.get('header-id') == 'hsm' ? 'text' : 'media'}
                                mediaType={this.state.isAuthentication ? null : formEdit.get('header-template') ? formEdit.get('header-template').toLowerCase() : ''}
                                buttons={formEdit.get('template-buttons')}
                                cardCarousel={form.get("template-type") === 'carousel'
                                                && <CardCarouselPreview templateCarousels={formEdit.get("template-carousels")} />}
                                lto={form.get("template-type") === 'lto' && ltoPreview }
                            />
                        </div>
                    </div>
                </div>
            )
        }
    }

    render() {
        const { hideButtonAdd, form, errors, disabledAll, disabledParent, templateType } = this.state;
        let disabledTemplate = false
        if (form.get('availableChange') == false) {
            disabledTemplate = true
        }

        return (
            <div className="card no-margin-bottom">
                <div className="body">
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Client</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='client-id'
                                value={form.get('client-id')}
                                options={fromJS({
                                    'source': this.props.clientall,
                                    'value': 'client-id',
                                    'label': 'client-name',
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Client"
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Division</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='division-id'
                                value={form.get('division-id')}
                                options={fromJS({
                                    'source': this.props.divisionall,
                                    'value': 'division-id',
                                    'label': 'division-name'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Division"
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Sender</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='sender-id'
                                value={form.get('sender-id')}
                                options={fromJS({
                                'source': this.props.senderall,
                                'value': 'sender-id',
                                'label': 'sender-name'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Sender"
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Name</span>
                        <div className="col-sm-10">
                            <TextInputField
                                className="form-control"
                                field={'template-name'}
                                value={form.get('template-name')}
                                onChange={(field, value) => this.handleChange(field, value)}
                                placeholder="template-name"
                                disabled={disabledTemplate || disabledParent || disabledAll}
                                hasError={errors.has('template-name')}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Category</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='category-id'
                                value={form.get('category-id')}
                                options={fromJS({
                                    'source': this.props.categoryTemplate,
                                    'value': 'id',
                                    'label': 'name'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Category"
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Name Space</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='namespace'
                                value={form.get('namespace')}
                                options={fromJS({
                                    'source': this.props.getnamespace,
                                    'value': 'namespace',
                                    'label': 'namespace'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="namespace"
                                disabled={true}
                            />
                        </div>
                    </div>
                    {(form.get('category-id') !== '1' && form.get('template-type')) && (
                        <div className="row no-margin-bottom">
                            <span className="col-sm-2">Template Type</span>
                            <div className="col-sm-10">
                                <ComboboxInput
                                    field='template-type'
                                    value={form.get('template-type')}
                                    options={fromJS({
                                        'source': templateType,
                                        'value': 'id',
                                        'label': 'name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Template Type"
                                    disabled={true}
                                />
                            </div>
                        </div>
                    )}
                    <div className={hideButtonAdd}>
                        <button type="button"
                            className="btn btn-wide btn-danger content-add ml-3 mr-3"
                            onClick={this.handleBack}>
                            {'Back'}
                        </button>
                        <button type="button"
                            className="btn btn-wide btn-success content-add"
                            onClick={this.handleAddLanguage}>
                            {'+ Add'}
                        </button>
                    </div>
                </div>
                {
                    this.showContent()
                }
            </div>
        );
    }
}


export default connect(
    (state) => {
        return {
            supervisorsall: state.user.supervisorsall,
            clientall: state.user.clientall,
            divisionall: state.user.divisionall,
            senderall: state.user.senders,
            categoryTemplate: state.user.categoryTemplate,
            languageTemplate: state.user.languageTemplate,
            getnamespace: state.user.getnamespace,
            accessmoduleaction: state.user.accessmoduleaction,

        }
    },
    dispatch => bindActionCreators({
        actionUploadFileExample: ActionUploadFileExample,
        actionAdd: ActionAdd,
        actionEdit: ActionEdit,
        actionGetAllClient: ActionGetAllClient,
        actionFetchAllDivision: ActionFetchAllDivision,
        actionFetchSender: ActionFetchSender,
        actionGetCategoryTemplate: ActionGetCategoryTemplate,
        actionGetLanguageTemplate: ActionGetLanguageTemplate,
        actionGetNameSpace: ActionGetNameSpace,
        actionGetAccessModuleIdAction: ActionGetAccessModuleIdAction,
    }, dispatch),
)(FormEdit);